import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import TextEditor from '../../../../../../../../shared-components/TextEditor';
import { format } from 'date-fns';
import { IconAddPlus } from '../../../../../../../shared/IconsComponent/icons';
import { useSelector } from 'react-redux';
import AddNewProblem from '../../../EncounterLeftPortion/Components/Tabs/Summary/Components/Problems/AddNewProblem';
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from '../../../../../../../Setup/Shared/ModalHeader';
import AddNewDocument from '../Components/AddNewDocument';
import DropdownValueHandler from '../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { enumUtil } from '../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../utils/ServerDataRequest';
import Loader from '../../../../../../../shared/Loader/Loader';
import SuperICDandCPTSearch from '../../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
import isNull from '../../../../../../../../utils/NullChecking';
import AddNewDiagnosis from '../../../../../../../Setup/Coding/DiagnosisCode/AddNewDiagnosis';
import EncounterPreview from './Components/EncounterPreview';
import useCaptureDataAndGeneratePDFBrowserAPI from '../../../../../../../shared/CaptureDataAndGeneratePDF/useCaptureDataAndGeneratePDFBrowserAPI';
import SignEncounter from '../Components/SignEncounter';
import handleNumericCheck from '../../../../../../../../utils/HandleNumericKeys';
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList';
import _ from 'lodash';
import AddNewProcedureCodes from '../../../../../../../Setup/Coding/ProcedureCode/AddNewProcedureCodes';
import ContentReceiver from '../../../../../../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver';
import FormatPhoneNumber from '../../../../../../../../utils/FormatPhoneNumber';
import PrintOutSelectDataModal from './Components/PrintOutSelectDataModal';
import { FindFirstChild, FindSecondChild } from '../../../../../../../../utils/FindMenuOption';
import useClaimLinkingEncounter from '../Components/useClaimLinkingEncounter';
import SignImagePreview from '../Components/SignImagePreview';
import PracticeDetailsPrintPopup from '../Components/PracticeDetailsPrintPopup';
import SelectedPreviewDataV2 from './Components/SelectedPreviewDataV2';
import FormatDate from '../../../../../../../shared/DateFormatter';
import DatePicker from '../../../../../../../General/DatePicker';
import HPIFields from '../SOAP/Components/HPIFields';
import ROSFields from '../SOAP/Components/ROSFields';
import CustomTemplateForm from '../Components/Custom Template Form/CustomTemplateForm';

const CustomNote = forwardRef(({
    initialData,
    saveSignal,
    setAccordions,
    searchParam,
    setSearchParam,
    showPreview,
    searchValue,
    setSaveQualityOfCareData,
    onSave,
    encounterID,
    ...props }, ref) => {

    console.log("patientIDCustom", props?.patientID)
    // {
    //     "QualityOfCareID" :"",
    //     "SummaryOfCareSent" : "false",
    //     "IncomingTransferOfPatient" : "false",
    //     "OutgoingTransferOfCare" : "false",
    //     "EducationMaterialGiven" : "true",
    //     "PatientDeclinedSummary" : "false",
    //     "VirtualVisit" : "true"
    // }
    let { printoutSelectDataModal,
        setPrintoutSelectDataModal,
        printoutModal,
        setPrintoutModal,
        isProcedureEdit,
        setIsProcedureEdit,
        patientID = null,
        mainServiceLineModal,
        setMainServiceLineModal,
        defaultSelectedItems,
        selectedItems,
        setSelectedItems,
        aiEncounterData,
        mainCustomTemplateData,
        setMainCustomTemplateData,
        setSaveMainCustomTemplateData,
        // selectedItems,
        // setSelectedItems 
    } = props;

    let isClaimViewAllowed = FindSecondChild('Billing', 'Claims', 'Claims')?.ISView;

    let isCreateClaimEditAllowed = FindFirstChild('Patient', 'Create Claim For SuperBill')?.IsAdd;
    let isSuperbillEditAllowed = FindFirstChild('Patient', 'Add SuperBill')?.IsAdd;
    let isSignEditAllowed = FindFirstChild('Patient', 'Sign Encounters')?.IsAdd;
    let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd ?? true;
    let IsDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted ?? true;
    const customNoteType = initialData?.Data?.NoteType;
    // const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })
    const [openTab, setOpenTab] = useState('')
    const [isSign, setIsSign] = useState(false);
    const quillSubjectiveNotesRef = useRef(null);
    const quillHPIRef = useRef(null);
    const quillROSRef = useRef(null);
    const quillObjectiveBehaviourRef = useRef(null);
    const quillInterventionRef = useRef(null);
    const quillResponseRef = useRef(null);
    const quillPrescriptionsRef = useRef(null);
    const quillSupplementsRef = useRef(null);
    const quillVaccinesRef = useRef(null);
    const quillInjectionsRef = useRef(null);
    const quillLabsRef = useRef(null);
    const quillImagingRef = useRef(null);
    const quillPlanRef = useRef(null);
    const quillFollowUpRef = useRef(null);
    const quillAdditionalInfoRef = useRef(null);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let RecentCPTs = useSelector(state => state.CodesDropDownReducer.RecentCPT)
    console.log("initialDatainitialData", initialData)
    const [isLoading, setIsLoading] = useState(false)
    const [selectedDiagnosisValue, setSelectedDiagnosisValue] = useState('')
    const [icdBody, setIcdBody] = useState({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": '' })
    let { divClaimLinking, LoadDD, dataExist } = useClaimLinkingEncounter(patientID, encounterID, props?.setReloadAfterSave);

    let Problems_Modal = {
        ProblemName: "",
        // OnSetDate: "",
        // ImplantableDeviceStatus: "",
    }
    const [showInActiveProblems, setShowInActiveProblems] = useState(false);
    // const [problemsSaveUpdateModal, setProblemsSaveUpdateModal] = useState([])
    const [mainProblemsModal, setMainProblemsModal] = useState(Problems_Modal);

    const [activeAccord, setActiveAccord] = useState({ 'SUBJECTIVE': true, 'OBJECTIVE': true, 'RESPONSE': true, 'PLAN': true, 'AdditionalINFO': true, });
    const [itemsCollapsed, setItemsCollapsed] = useState({});

    let SUBJECTIVE_MODEL = {
        // "SubjectiveNotes": initialData?.Data?.SubjectiveNotes || "",
        "ChiefComplaint": initialData?.Data?.ChiefComplaint || "",
        "HistoryofPresentIllnessNotes": initialData?.Data?.HistoryofPresentIllnessNotes || "",
        "HistoryOfPresentIllness": initialData?.HistoryOfPresentIllness || {},
        "ReviewOfSystemNotes": initialData?.Data?.ReviewOfSystemNotes || "",
        "ReviewOfSystem": initialData?.ReviewOfSystem || {},
    }
    const [subjectiveData, setSubjectiveData] = useState(SUBJECTIVE_MODEL);

    let OBJECTIVE_MODEL = {
        "BehaviourNotes": initialData?.Data?.BehaviourNotes || "",
        // "Vital": initialData?.Vital || [],
    }
    const [objectiveData, setObjectiveData] = useState(OBJECTIVE_MODEL);

    let INTERVENTION_MODEL = {
        "InterventionNotes": initialData?.Data?.InterventionNotes || "",
    }
    const [interventionData, setInterventionData] = useState(INTERVENTION_MODEL);

    let ASSESSMENT_MODEL = {
        "ResponseNotes": initialData?.Data?.ResponseNotes || "",
        "EncounterProblem": initialData?.EncounterProblem || [],
    }
    const [assessmentData, setAssessmentData] = useState(ASSESSMENT_MODEL);

    let PLAN_MODEL = {
        "PrescriptionsNotes": initialData?.Data?.PrescriptionsNotes || "",
        "SupplementsNotes": initialData?.Data?.SupplementsNotes || "",
        "VaccinesNotes": initialData?.Data?.VaccinesNotes || "",
        "InjectionsNotes": initialData?.Data?.InjectionsNotes || "",
        "LabsNotes": initialData?.Data?.LabsNotes || "",
        "ImagingNotes": initialData?.Data?.ImagingNotes || "",
        "PlanNotes": initialData?.Data?.PlanNotes || "",
        "FollowUpDate": !isNull(initialData?.Data?.FollowUpDate) ? FormatDate(initialData?.Data?.FollowUpDate) : "",
        "FollowUpNotes": initialData?.Data?.FollowUpNotes || "",
        // "Vital": initialData?.Vital || [],
    }
    const [planData, setPlanData] = useState(PLAN_MODEL);
    // const [addVital, setAddVital] = useState(false);
    const API_URL = enumUtil.controller.Claim;
    const API_URL_GENERAL = enumUtil.controller.General;

    let RecentICDs = useSelector(state => state.CodesDropDownReducer.RecentICD)
    let RecentModifiers = useSelector(state => state.CodesDropDownReducer.RecentModifier)

    const [PatDxData, setPatDxData] = useState([])

    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;

    const [vitalData, setVitalData] = useState([{
        PatientID: patientID,
        VitalID: "0",
        VitalName: "Height",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "Weight",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "BMI",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "BMI Percentile",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "BP",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "Temperature",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "Pulse",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "Respiratory Rate",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "O2 Saturation",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "Pain",
        VitalValue: ""
    }, {
        PatientID: patientID,
        VitalID: "0",
        VitalName: "Head Circumference",
        VitalValue: ""
    }]);

    let vitalKeysList = [
        "Height",
        "Weight",
        "BMI",
        "BMI Percentile",
        "BP",
        "Temperature",
        "Pulse",
        "Respiratory Rate",
        "O2 Saturation",
        "Pain",
        "Head Circumference"
    ];

    // let vitalUnitList = [
    //     "in",
    //     "lb",
    //     "",
    //     "%",
    //     "",
    //     "",
    //     "",
    //     "",
    //     "%",
    //     "",
    //     "cm"
    // ];

    // US Customary Units
    let vitalUnitListUS = [
        "in",   // Height
        "lb",   // Weight
        "",     // BMI
        "%",    // BMI Percentile
        "mmHg", // BP
        "°F",   // Temperature
        "bpm",  // Pulse
        "breaths/min", // Respiratory Rate
        "%",    // O2 Saturation
        "",     // Pain
        "in"    // Head Circumference
    ];

    // Metric Units
    let vitalUnitListMetric = [
        "cm",   // Height
        "kg",   // Weight
        "",     // BMI
        "%",    // BMI Percentile
        "mmHg", // BP
        "°C",   // Temperature
        "bpm",  // Pulse
        "breaths/min", // Respiratory Rate
        "%",    // O2 Saturation
        "",     // Pain
        "cm"    // Head Circumference
    ];

    const vitalUnitList = useMemo(() => {
        if (searchParam?.VitalUnitType === "US Customary") {
            return vitalUnitListUS;
        } else if (searchParam?.VitalUnitType === "Metric") {
            return vitalUnitListMetric;
        }
    }, [searchParam?.VitalUnitType]);


    let AdditionalINFO_MODEL = {
        "AdditionalInfoNotes": initialData?.Data?.AdditionalInfoNotes || "",
        "EncounterDocument": initialData?.EncounterDocument || [],
    }

    const API_URL_PATIENTENCOUNTER = enumUtil.controller.PatientEncounter
    const [is, setIs] = useState(false);
    const [additionalInfoData, setAdditionalInfoData] = useState(AdditionalINFO_MODEL);

    let QUALITY_OF_CARE_MODEL = {
        ...initialData?.QualityOfCare
    }
    const [qualityOfCareData, setQualityOfCareData] = useState(QUALITY_OF_CARE_MODEL);
    console.log("initialDataSUPER_BILL_MODEL", initialData)
    let SUPER_BILL_MODEL = [
        // ...initialData?.SuperBill
    ]
    const [superBillData, setSuperBillData] = useState(SUPER_BILL_MODEL);
    const [isOpenProblems, setIsOpenProblems] = useState(false);
    const [problemsID, setProblemsID] = useState();
    const [problemModal, setProblemModal] = useState({});
    const [saveProblemsData, setSaveProblemsData] = useState([]);

    const [isOpenDocument, setIsOpenDocument] = useState(false);
    const [documentID, setDocumentID] = useState();
    const [documentModal, setDocumentModal] = useState({});
    const [saveDocumentData, setSaveDocumentData] = useState([]);
    const [vitalsPastData, setVitalsPastData] = useState({});
    const [pastVitalsLoaded, setPastVitalsLoaded] = useState(false);

    /////// History of Present Illness ////////
    const [saveHPIData, setSaveHPIData] = useState({
        "HistoryOfPresentIllnessID": "",
        ...initialData?.HistoryOfPresentIllness
    });
    /////// Review of System ////////
    const [saveROSData, setSaveROSData] = useState({
        "ReviewOfSystemID": "",
        ...initialData?.ReviewOfSystem
    });

    const handleAccordionChange = (key) => {
        setAccordions(prev => prev.map(accord => accord.key === key ? { ...accord, active: !accord.active } : { ...accord }));
        handleAccord(key);
    }

    const handleHoveredItem = (id) => {
        if (!pastVitalsLoaded && id === "ref-OBJECTIVE-Vitals") return;
        props?.setHoveredItem(id);
    }

    const handleActiveItem = (id) => {
        props?.setActiveID(id);

        const elementBar = document.getElementById(`vertical-bar-${id}`);
        if (elementBar) {
            elementBar.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const handleAccord = (name) => {
        setActiveAccord(prev => ({ ...prev, [name]: !prev[name] }))
    }

    const handleItemsExpanded = (name) => {
        setItemsCollapsed(prev => ({ ...prev, [name]: !prev[name] }))
    }

    const handleChange = (e, type) => {

        let { name, value } = e.target;

        if (type === 'Subjective') {
            setSubjectiveData(prev => ({
                ...prev, [name]: e.target.value,
            }));
        }

        if (type === 'Behaviour') {
            setObjectiveData(prev => ({
                ...prev, "BehaviourNotes": e.target.value,
            }));
        }

        if (type === 'Intervention') {
            setInterventionData(prev => ({
                ...prev, "InterventionNotes": e.target.value,
            }));
        }

        if (type === 'Response') {
            setAssessmentData(prev => ({
                ...prev, "ResponseNotes": e.target.value,
            }));
        }

        // if (type === 'Plan') {
        //     setPlanData(prev => ({
        //         ...prev, "PlanNotes": e.target.value,
        //     }));
        // }
        if (type === 'Plan') {
            setPlanData(prev => ({
                ...prev, [name]: value,
            }));
        }

    }


    const handleChangeFreeText = (value, type) => {

        if (type === 'HistoryofPresentIllnessNotes') {
            setSubjectiveData(prev => ({
                ...prev, "HistoryofPresentIllnessNotes": value,
            }));
        }
        if (type === 'ReviewOfSystemNotes') {
            setSubjectiveData(prev => ({
                ...prev, "ReviewOfSystemNotes": value,
            }));
        }

        if (type === 'Behaviour') {
            setObjectiveData(prev => ({
                ...prev, "BehaviourNotes": value,
            }));
        }

        if (type === 'Intervention') {
            setInterventionData(prev => ({
                ...prev, "InterventionNotes": value,
            }));
        }

        if (type === 'Response') {
            setAssessmentData(prev => ({
                ...prev, "ResponseNotes": value,
            }));
        }

        // Plan
        if (type === 'PrescriptionsNotes') {
            setPlanData(prev => ({
                ...prev, "PrescriptionsNotes": value,
            }));
        }
        if (type === 'SupplementsNotes') {
            setPlanData(prev => ({
                ...prev, "SupplementsNotes": value,
            }));
        }
        if (type === 'VaccinesNotes') {
            setPlanData(prev => ({
                ...prev, "VaccinesNotes": value,
            }));
        }
        if (type === 'InjectionsNotes') {
            setPlanData(prev => ({
                ...prev, "InjectionsNotes": value,
            }));
        }
        if (type === 'LabsNotes') {
            setPlanData(prev => ({
                ...prev, "LabsNotes": value,
            }));
        }
        if (type === 'ImagingNotes') {
            setPlanData(prev => ({
                ...prev, "ImagingNotes": value,
            }));
        }
        if (type === 'Plan') {
            setPlanData(prev => ({
                ...prev, "PlanNotes": value,
            }));
        }
        if (type === 'FollowUpNotes') {
            setPlanData(prev => ({
                ...prev, "FollowUpNotes": value,
            }));
        }
        if (type === 'AdditionalInfo') {
            setAdditionalInfoData(prev => ({
                ...prev, "AdditionalInfoNotes": value,
            }));
        }
    }
    ////////////// setMainServiceLineModal //////////////////
    useEffect(() => {
        setMainServiceLineModal(initialData?.SuperBill);
    }, []);
    /// Update PatDxData if Problem Added in Save Modal ///
    useEffect(() => {
        if (!isOpenProblems && saveProblemsData?.length > 0) {
            setPatDxData(prev => {
                const existingIDs = prev.map(item => item.DiagnosisCodeID);
                const newItems = saveProblemsData.filter(
                    item => !existingIDs.includes(item.DiagnosisCodeID)
                ).map(it => ({
                    ...it,
                    display: it.DiagnosisCode,
                    value: it.DiagnosisCodeID
                }));
                return [...prev, ...newItems];
            });
        }
    }, [isOpenProblems])

    const getStructerdSaveData = () => {
        let { Data, ...restObj } = { ...initialData };
        let { UpdateDate, UpdatedBy, TableName, ...data } = { ...Data };
        let { HistoryOfPresentIllness, ReviewOfSystem, ...saveSubjectiveData } = subjectiveData;
        Data = {
            ...data,
            ...searchParam,
            ...(saveSubjectiveData || {}),
            // "BehaviourNotes": objectiveData?.BehaviourNotes,
            // "InterventionNotes": interventionData?.InterventionNotes,
            // "ResponseNotes": assessmentData?.ResponseNotes,
            // "PrescriptionsNotes": planData?.PrescriptionsNotes || "",
            // "SupplementsNotes": planData?.SupplementsNotes || "",
            // "VaccinesNotes": planData?.VaccinesNotes || "",
            // "InjectionsNotes": planData?.InjectionsNotes || "",
            // "LabsNotes": planData?.LabsNotes || "",
            // "ImagingNotes": planData?.ImagingNotes || "",
            // "PlanNotes": planData?.PlanNotes,
            ///////////////////////////////////////////////
            "FollowUpDate": planData?.FollowUpDate || "",
            "FollowUpNotes": planData?.FollowUpNotes || "",
            "AdditionalInfoNotes": additionalInfoData?.AdditionalInfoNotes,
        };
        let vitalValExist = vitalData.some(key => !isNull(key.VitalValue));

        let { TableName: TableNameHPI, ...hpiDataSave } = saveHPIData;
        let { TableName: TableNameROS, ...rosDataSave } = saveROSData;
        restObj = {
            ...restObj,
            "EncounterCoSign": props?.saveEncounterCoSignData,
            "MainCustomTemplate": props?.saveMainCustomTemplateData,
            "CustomTemplate": props?.saveCustomTemplateData,
            "Vital": vitalValExist ? vitalData : [],
            "EncounterProblem": saveProblemsData,
            "EncounterDocument": saveDocumentData,
            "EncounterAddendum": props?.saveAddendumData,
            "QualityOfCare": props?.saveQualityOfCareData,
            "SuperBill": mainServiceLineModalSaveData,
            "HistoryOfPresentIllness": hpiDataSave,
            "ReviewOfSystem": rosDataSave,
        }

        // setAddVital(false);
        return { ...restObj, Data };
    }

    useEffect(() => {
        if (saveSignal) {
            let saveData = getStructerdSaveData();
            onSave(customNoteType, saveData);
        }
    }, [saveSignal]);

    // const getVitalKeys = () => {
    //     let keys = []
    //     initialData.Vital.map(encounter => (
    //         encounter.Vital.map(vital => (
    //             !keys.includes(vital.VitalName) && keys.push(vital.VitalName)
    //         ))
    //     ))
    //     return keys
    // }
    // let vitalKeys = getVitalKeys();

    // const handleAddVital = () => {
    //     // setVitalData(prev => ({
    //     //     ...prev, 
    //     //     // Date: format(new Date, 'MM/dd/yyy'), 
    //     //     // Time: format(new Date(), 'hh:mm a')
    //     // }));
    //     // setVitalData()   
    //     // setAddVital(true);
    // }


    const AddDocument = (doc) => {
        setDocumentID(doc.PatientDocumentID || "0");
        setDocumentModal(doc);
        setIsOpenDocument(prev => !prev);
    }
    const CloseDocument = () => {
        setIsOpenDocument(false)
    }
    let PopupScreenDocument = "";
    if (isOpenDocument) {
        PopupScreenDocument = <AddNewDocument isOpenDocument={isOpenDocument} PatientDocumentID={documentID} documentModal={documentModal} setDocumentModal={setDocumentModal} onClose={CloseDocument} // onDeleteProblems={DeleteProblems} 
            setIsRecordSaved={() => { }}
            setSaveDocumentData={setSaveDocumentData}
            setAdditionalInfoData={setAdditionalInfoData}
            isOpenedFrom={'SOAP'}
        />
    }

    // useEffect(() => {
    //     const observer = new IntersectionObserver((entries) => {
    //         console.log("isOpenedFromobserversaveProblemsData", entries)
    //         entries
    //             .filter(ent => ent.isIntersecting)
    //             .forEach((entry, index) => {
    //                 if (index === 0 && entry.target.id.startsWith('ref-')) {
    //                     props?.setActiveID(entry.target.id);
    //                 }
    //             });
    //     }, {
    //         threshold: 0.8,
    //     });

    //     const elementsWithId = Array.from(document.querySelectorAll('[id]'));
    //     const filteredElements = elementsWithId.filter(el => el.id.startsWith('ref-'));

    //     filteredElements.forEach(el => observer.observe(el));

    //     return () => {
    //         filteredElements.forEach(el => observer.unobserve(el));
    //     };
    // }, []);

    const LoadVitalsData = () => {
        if (!searchParam?.EncounterDate) return;
        // setIsLoading(true);
        setPastVitalsLoaded(false);
        setVitalsPastData({})
        ServerRequestProtected(API_URL_PATIENTENCOUNTER + "/GetPastVital", 'post', {
            "TableName": enumUtil.enumAPITableName.Vital,
            "SearchCriteria": {
                "PatientID": patientID,
                "EncounterDate": searchParam.EncounterDate
            }
        })
            .then((response) => {
                // setIsLoading(false);
                setVitalsPastData(response);
                setPastVitalsLoaded(true);
            }).catch((error) => {
                // setIsLoading(false)
                setPastVitalsLoaded(false);
            })
    }

    useEffect(() => {
        LoadVitalsData();
        LoadDD(searchParam?.EncounterDate);
    }, [searchParam?.EncounterDate]);

    // console.log("isOpenedFrom saveProblemsData", saveProblemsData)
    console.log("isOpenedFrom saveDocumentData", saveDocumentData)
    // console.log("isOpenedFrom vitalsPastData", vitalsPastData)

    const handleAddProblemWithDefaultICD = (selectedData) => {
        setSelectedDiagnosisValue(selectedData)
        AddProblems(null);
    }
    const PatDx = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/CodesSearch", 'post', {
            "TableName": enumUtil.enumAPITableName.Diagnosis,
            "SEARCHCRITERIA": {
                "Param": "PatientProblems",
                "Search": null,
                "PatientID": patientID + "",
            },
            "value": "0",
            "PERPAGE": "100",
            "PAGENO": "1"
        }).then((response) => {
            setIsLoading(false)
            setPatDxData(response.Rows)
        }).catch((error) => {
            setIsLoading(false)
            setPatDxData([])
        })
    }

    useEffect(() => {
        if (!isNull(props?.patientID)) {
            PatDx();
            LoadLastEncounterProblem();
            LoadLastEncounterCPT();
        }
    }, [props?.patientID])

    useEffect(() => {
        if (!isNull(props?.patientID) && props?.isRecordSaved && props?.isRecordSavedType === 'Problems') {
            PatDx()
        }
    }, [props?.patientID, props?.isRecordSaved])

    const AddProblems = (ID, prob) => {
        setProblemsID(ID)
        setProblemModal(prob);
        setIsOpenProblems(prev => !prev);
    }
    const CloseProblems = () => {
        setIsOpenProblems(false)
    }
    let PopupScreenProblems = "";
    if (isOpenProblems) {
        PopupScreenProblems = <AddNewProblem isOpenProblems={isOpenProblems} problemsID={problemsID} setProblemsID={setProblemsID}
            patientID={patientID}
            onClose={CloseProblems} // onDeleteProblems={DeleteProblems} 
            // isOpen={}
            selectedDiagnosisValue={selectedDiagnosisValue}
            setSelectedDiagnosisValue={setSelectedDiagnosisValue}
            problemModal={problemModal}
            setProblemModal={setProblemModal}
            setIsRecordSaved={() => { }}
            setSaveProblemsData={setSaveProblemsData}
            setAssessmentData={setAssessmentData}
            isOpenedFrom={'SOAP'}
            IsEditAllowed={IsEditAllowed}
            IsDeleteAllowed={IsDeleteAllowed}
        />
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainProblemsModal };
        if (type === 'client' && !isNull(selectedData)) {
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'ProblemName') {
                const exists = assessmentData?.EncounterProblem?.some(item => item.DiagnosisCodeID == selectedData.DiagnosisCodeID);
                if (exists) return;
                if (!selectedData.PatientProblemListID) {
                    selectedData.Acuity = selectedData.Acuity ? (selectedData.Acuity + "") : 'Undefined';
                    handleAddProblemWithDefaultICD(selectedData);
                    modal[name] = '';
                } else {

                    // console.log("ELSEHandleSelectedData" ,   updatedEncounterProblem)
                    setAssessmentData(prev => {
                        let encounterLength = prev?.EncounterProblem?.length || 0;
                        // Check save state for deleted item
                        const savedItem = saveProblemsData.find(x => x.PatientProblemListID === selectedData.PatientProblemListID);
                        let mergedData = selectedData;

                        if (savedItem && savedItem.Deleted === "true") {
                            // Restore IDs from deleted item
                            mergedData = {
                                ...selectedData,                  // latest fields from UI
                                EncounterProblemID: savedItem.EncounterProblemID,
                                PatientProblemListID: savedItem.PatientProblemListID,
                                EncounterID: savedItem.EncounterID,
                                Deleted: "false"
                            };
                        }
                        // ----------------------------
                        // Check if exists in AssessmentData
                        // ----------------------------
                        const idExist = prev.EncounterProblem?.some(
                            item => item.PatientProblemListID === selectedData.PatientProblemListID
                        );

                        const updatedEncounterProblem = idExist
                            ? prev.EncounterProblem.map(item =>
                                item.PatientProblemListID === selectedData.PatientProblemListID
                                    ? {
                                        ...mergedData,
                                        recordNoClient: String(encounterLength + 1)
                                    }
                                    : item
                            )
                            : [...(prev.EncounterProblem || []), {
                                ...mergedData,
                                recordNoClient: String(encounterLength + 1)
                            }];

                        return { ...prev, EncounterProblem: updatedEncounterProblem };
                    });

                    // console.log("selectedDataselectedData1", selectedData)
                    //  Update SaveProblemsData
                    if (!selectedData?.EncounterProblemID) {
                        selectedData.EncounterProblemID = "";
                    }

                    // console.log("selectedDataselectedData2", selectedData)

                    setSaveProblemsData(prev => {
                        const prevItem = prev.find(x => x.DiagnosisCodeID === selectedData.DiagnosisCodeID);
                        console.log("prevItem12", prevItem)
                        if (prevItem) {
                            // Restore if it was deleted
                            const restoredItem = prevItem.Deleted === "true" ? { ...prevItem, Deleted: "false" } : prevItem;
                            // Merge latest fields from prob but keep IDs from restoredItem
                            return prev.map(item =>
                                item.PatientProblemListID === restoredItem.PatientProblemListID
                                    ? {
                                        ...item,          // keep existing data in prev array
                                        ...selectedData,          // apply latest fields
                                        EncounterProblemID: restoredItem.EncounterProblemID, PatientProblemListID: restoredItem.PatientProblemListID, EncounterID: restoredItem.EncounterID,
                                        Deleted: restoredItem.Deleted
                                    } : item
                            );
                        }
                        // If not in existingList, check if selectedData exists in prev
                        const idExist = prev.some(item => item.PatientProblemListID === selectedData.PatientProblemListID);
                        if (idExist) {
                            return prev.map(item =>
                                item.PatientProblemListID === selectedData.PatientProblemListID ? selectedData : item
                            );
                        } else {
                            return [...prev, selectedData];
                        }
                    });
                }
            }
        } else {

            modal[name] = ''
            // problemsSaveUpdateModal[name] = ''
            if (name === 'ProblemName') {
                // setProblemNameSelected(false);
            }
        }
        setMainProblemsModal(modal);
        // setProblemsSaveUpdateModal(problemsSaveUpdateModal);
        return selectedData
    }
    const handleDeviceChange = (e) => {
        setIs(false)
        setMainProblemsModal(prev => ({ ...prev, ProblemName: e.target.value }));
        setIcdBody({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": e.target.value })
    }

    const ShowHideInActive = () => {
        // console.log("assessmentData?.EncounterProblem",assessmentData?.EncounterProblem)
        const condition = (item) => (item.isActive === "false");
        // const condition = (item) => (item.isActive === "false") && !["", "0", 0, undefined].includes(item.EncounterProblemID)
        let inActiveCount = assessmentData?.EncounterProblem?.filter(condition).length;
        return inActiveCount > 0 ? <p className='heading validate-color cursor-pointer' onClick={() => setShowInActiveProblems(prev => !prev)}>
            {showInActiveProblems ? `Hide InActive(${inActiveCount})` : `Show InActive(${inActiveCount})`}
        </p> : null
    }

    const [isOpenNewDiagnosis, setisOpenNewDiagnosis] = useState(false)
    const [icdCode, setIcdCode] = useState()
    const [ActiveICDName, setActiveICDName] = useState('')

    let Procedure_Code_Modal = {
        CPT: "",
    }
    const [CPTModal, setCPTModal] = useState(Procedure_Code_Modal);
    const handleAddNewICD = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenNewDiagnosis(true)
    }
    const handleCloseICD = () => {
        setisOpenNewDiagnosis(false)
    }
    const handleOnSaveICD = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectedData(selectedData, ActiveICDName, 'server')
        }
    }
    let PopupNewICD = ''
    if (isOpenNewDiagnosis) {
        PopupNewICD = <AddNewDiagnosis isOpenDiagnosis={isOpenNewDiagnosis} onClose={handleCloseICD} Diagnosisvalue={icdCode} onDeleteProcedure={handleCloseICD} onDeleteDiagnosis={handleCloseICD} IsOpen={true} onICDSave={handleOnSaveICD} />
    }
    const handleProblemDelete = (item) => {
        const { DiagnosisCodeID } = item;
        console.log("axd DiagnosisCodeID 1", DiagnosisCodeID)
        setAssessmentData(prev => {
            console.log("axd DiagnosisCodeID 2", prev.EncounterProblem)
            const filteredEncounterProblem = (prev.EncounterProblem || []).filter(
                p => p.DiagnosisCodeID !== DiagnosisCodeID
            );
            // console.log("DiagnosisCodeID", 
            //     DiagnosisCodeID,
            //     prev.EncounterProblem,
            //     filteredEncounterProblem
            // )
            console.log("axd DiagnosisCodeID 3", filteredEncounterProblem)
            return { ...prev, EncounterProblem: filteredEncounterProblem };
        });
        setSaveProblemsData(prev => {
            let found = false;

            const updated = prev.reduce((acc, p) => {
                if (p.DiagnosisCodeID === DiagnosisCodeID) {
                    found = true;
                    const isEncounterProblemIDNull = isNull(p.EncounterProblemID);
                    if (!isEncounterProblemIDNull) {
                        acc.push({ ...p, Deleted: "true" }); // mark as deleted
                    }
                    // else: skip (removes the item)
                } else {
                    acc.push(p); // keep others
                }
                return acc;
            }, []);

            if (!found) {
                updated.push({
                    DiagnosisCodeID: item?.DiagnosisCodeID,
                    EncounterID: item?.EncounterID,
                    EncounterProblemID: item?.EncounterProblemID,
                    PatientProblemListID: item?.PatientProblemListID,
                    Deleted: "true", // or whatever logic you need
                });
            }

            return updated;
        });

    }
    const handleDocumentDelete = (item, indexToRemove) => {
        const { PatientDocumentID, recordNoClient } = item;

        // Remove from EncounterDocument list by index
        setAdditionalInfoData(prev => {
            const updatedEncounterDocument = prev.EncounterDocument.filter((_, idx) => idx !== indexToRemove);
            return { ...prev, EncounterDocument: updatedEncounterDocument };
        });
        // Update saveDocumentData accordingly
        setSaveDocumentData(prev => {
            if (PatientDocumentID) {
                const exists = prev.some(doc => doc.PatientDocumentID === PatientDocumentID);

                if (exists) {
                    //  Update it to mark as deleted
                    return prev.map(doc =>
                        doc.PatientDocumentID === PatientDocumentID
                            ? { ...doc, Deleted: "true" }
                            : doc
                    );
                } else {
                    //  Push a new deleted object if it doesn't exist yet
                    return [
                        ...prev,
                        {
                            PatientDocumentID,
                            EncounterID: item.EncounterID,
                            Deleted: "true",
                        },
                    ];
                }
            } else if (recordNoClient) {
                //  Remove unsaved local doc entirely
                return prev.filter(doc => doc.recordNoClient !== recordNoClient);
            } else {
                return prev;
            }
        });
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };

    const componentRef = useRef(null);
    const { isLoading: isLoadingPdf, captureDataAndGeneratePDF } = useCaptureDataAndGeneratePDFBrowserAPI();
    // let DEFAULT_PREVIEW_SELECTED = {
    //     "patientSummary": true,
    //     "chiefComplaint": true,
    //     "problems": true,
    //     "behaviourNotes": true,
    //     "interventionNotes": true,
    //     "responseNotes": true,
    //     "planNotes": true,
    //     "uiDesign" : false,
    // };
    // const [selectedItems, setSelectedItems] = useState(DEFAULT_PREVIEW_SELECTED);
    const [showAddressTypeLocation, setShowAddressTypeLocation] = useState('false');
    const handleEditProcedure = () => {
        if (!isSuperbillEditAllowed) return;
        setIsProcedureEdit(prev => !prev)
    }
    const { PatientName, Age, DOB, Address, MobileNumber, Email, } = initialData?.Data;

    // const [mainServiceLineModal, setMainServiceLineModal] = useState(initialData?.SuperBill);
    // const [mainServiceLineModalSaveData, setMainServiceLineModalSaveData] = useState([]);
    const [modifierBody, setmodifierBody] = useState({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": '' })
    const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })

    const mainServiceLineModalSaveData = useMemo(() => {
        return mainServiceLineModal.filter(it => it.isUpdated === 'true').map(({ isUpdated, ...rest }) => rest);
    }, [mainServiceLineModal]);


    const handleServiceLineChange = (e, id, index, type, isMainCPTEncounterCustomNote) => {
        if (!isSuperbillEditAllowed) return;
        setIs(false)
        let { name, value } = e.target;
        if (type === 'ProcedureCode') {
            setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": value })
        } else if (type === 'Modifier') {
            setmodifierBody({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": value })
        } else if (name === 'RevenueCode') {
            // setRevCodeBody({ "TableName": enumUtil.enumAPITableName.RevenueCode, "SearchParam": value })
        }
        if (isMainCPTEncounterCustomNote === "isMainCPTEncounterCustomNote") {
            setCPTModal(prev => ({ ...prev, CPT: value }))
        } else {
            let serviceLineItem = [...mainServiceLineModal];
            serviceLineItem[index][name] = value;
            serviceLineItem[index]['isUpdated'] = 'true';
            setMainServiceLineModal(serviceLineItem);
        }
        // if (name === 'PerUnitAmount') {
        // serviceLineItem[index]['Amount'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBalance'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBilledAmount'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // // calculateAmounts(mainServiceLineModal)
        // }
        // if (name === 'Units') {
        // serviceLineItem[index]['Amount'] = parseFloat(serviceLineItem[index]['PerUnitAmount'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBalance'] = parseFloat(serviceLineItem[index]['PerUnitAmount'] * value).toFixed(2)
        // serviceLineItem[index]['PrimaryBilledAmount'] = parseFloat(serviceLineItem[index]['Units'] * value).toFixed(2)
        // // calculateAmounts(mainServiceLineModal)
        // }

    }

    // const handleOnblurServiceline = (e, index) => {
    //     const { value, name } = (e.target)
    //     let serviceLineItem = [...mainServiceLineModal];
    //     let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));
    //     if (name === 'Pointer1' || name === 'Pointer2' || name === 'Pointer3' || name === 'Pointer4') {
    //         let pointer1 = serviceLineItem[index]['Pointer1'] + ""
    //         let pointer2 = serviceLineItem[index]['Pointer2'] + ""
    //         let pointer3 = serviceLineItem[index]['Pointer3'] + ""
    //         let pointer4 = serviceLineItem[index]['Pointer4'] + ""
    //         let pointer = [pointer1, pointer2, pointer3, pointer4]
    //         let intValue = parseInt(value)
    //         let icdIndex = 'ICD' + value + 'Code'
    //         // debugger
    //         if (intValue < 1 || intValue > 12 && !isNaN(intValue)) {
    //             serviceLineValidationCopy[index][name + 'ICD'] = 'pointer value cannot be less than 1 and greater than 12'
    //         } else if (
    //             // isNull(mainDiagnosisModal[icdIndex]) &&
    //             icdIndex !== 'ICDCode') {
    //             // if (!isNull(icdIndex)) {
    //             //     if (isNull(value)) {
    //             //         serviceLineValidationCopy[index][name + 'ICD'] = ''
    //             //     } else {
    //             //         serviceLineValidationCopy[index]['Pointer1UNI'] = ''
    //             //         serviceLineValidationCopy[index][name + 'ICD'] = 'Cannot add pointer against empty ICD'
    //             //     }
    //             // }
    //         } else {
    //             serviceLineValidationCopy[index][name + 'ICD'] = ''
    //             const uniqueSet = new Set();
    //             let hasDuplicates = false;

    //             for (const item of pointer) {
    //                 if (!isNull(item)) {
    //                     if (uniqueSet.has(item)) {
    //                         hasDuplicates = true;
    //                         break;
    //                     }
    //                     uniqueSet.add(item);
    //                 }
    //             }

    //             if (hasDuplicates) {
    //                 serviceLineValidationCopy[index]['Pointer1UNI'] = 'Pointers must be unique'
    //             } else {
    //                 serviceLineValidationCopy[index]['Pointer1UNI'] = ''
    //             }
    //         }
    //         let foundNull = false;
    //         let Error = false;
    //         for (let i = 0; i < 4; i++) {
    //             if (isNull(pointer[i])) {
    //                 foundNull = true
    //             }
    //             if (!isNull(pointer[i]) && foundNull === true) {
    //                 Error = true
    //             }
    //         }
    //         if (Error) {
    //             serviceLineValidationCopy[index]['Pointer1Val'] = 'Pointers must be in sequence'
    //         } else {
    //             serviceLineValidationCopy[index]['Pointer1Val'] = ''
    //         }
    //         console.log("serviceLineValidationCopy",serviceLineValidationCopy)
    //         setServiceLineValidation(serviceLineValidationCopy)
    //     }
    // }
    const handleOnblurServiceline = (e, index) => {
        const { value, name } = e.target;
        let serviceLineItem = [...mainServiceLineModal];
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));

        // Ensure index exists
        if (!serviceLineValidationCopy[index]) {
            serviceLineValidationCopy[index] = {};
        }

        if (name === 'Pointer1' || name === 'Pointer2' || name === 'Pointer3' || name === 'Pointer4') {
            let pointer1 = (serviceLineItem[index]['Pointer1'] || '') + "";
            let pointer2 = (serviceLineItem[index]['Pointer2'] || '') + "";
            let pointer3 = (serviceLineItem[index]['Pointer3'] || '') + "";
            let pointer4 = (serviceLineItem[index]['Pointer4'] || '') + "";
            let pointer = [pointer1, pointer2, pointer3, pointer4];
            let intValue = parseInt(value);
            let icdIndex = 'ICD' + value + 'Code';

            if ((intValue < 1 || intValue > 12) && !isNaN(intValue)) {
                serviceLineValidationCopy[index][name + 'ICD'] = 'pointer value cannot be less than 1 and greater than 12';
            } else if (icdIndex !== 'ICDCode') {
                // Placeholder: previously commented logic — kept untouched to avoid affecting old functionality
            } else {
                serviceLineValidationCopy[index][name + 'ICD'] = '';

                const uniqueSet = new Set();
                let hasDuplicates = false;

                for (const item of pointer) {
                    if (!isNull(item)) {
                        if (uniqueSet.has(item)) {
                            hasDuplicates = true;
                            break;
                        }
                        uniqueSet.add(item);
                    }
                }

                serviceLineValidationCopy[index]['Pointer1UNI'] = hasDuplicates
                    ? 'Pointers must be unique'
                    : '';
            }

            // Check sequence validity
            let foundNull = false;
            let Error = false;
            for (let i = 0; i < 4; i++) {
                if (isNull(pointer[i])) {
                    foundNull = true;
                }
                if (!isNull(pointer[i]) && foundNull === true) {
                    Error = true;
                }
            }

            serviceLineValidationCopy[index]['Pointer1Val'] = Error
                ? 'Pointers must be in sequence'
                : '';

            console.log("serviceLineValidationCopy", serviceLineValidationCopy);
            setServiceLineValidation(serviceLineValidationCopy);
        }
    };


    console.log("mainServicelineModalProcedureCodeProcedureCode", mainServiceLineModal)
    let SERVICE_LINE_MODAL = {
        "SuperBillID": "",
        "ProcedureCodeID": "",
        "ProcedureCode": "",
        "Pointer1": "",
        "Pointer2": "",
        "Pointer3": "",
        "Pointer4": "",
        "ModifierCodeID1": "",
        "ModifierCode1": "",
        "ModifierCodeID2": "",
        "ModifierCode2": "",
        "ModifierCodeID3": "",
        "ModifierCode3": "",
        "ModifierCodeID4": "",
        "ModifierCode4": "",
        "Units": "1",
        "Deleted": "false",
        "isUpdated": "false",
    };
    let ServiceLineValidation_Modal = {
        // DOSFromVal: '',
        // DOSToVal: '',
        // CPTCodeVal: '',
        // ModifierCode1Val: '',
        // ModifierCode1UNI: '',
        // ModifierCode2Val: '',
        // ModifierCode2UNI: '',
        // ModifierCode3Val: '',
        // ModifierCode3UNI: '',
        // ModifierCode4Val: '',
        // ModifierCode4UNI: '',
        Pointer1Val: '',
        Pointer1UNI: '',
        Pointer2Val: '',
        Pointer2UNI: '',
        Pointer3Val: '',
        Pointer3UNI: '',
        Pointer4Val: '',
        Pointer4UNI: '',
        Pointer1ICD: '',
        Pointer2ICD: '',
        Pointer3ICD: '',
        Pointer4ICD: '',
        // POSVal: '',
        UnitsVal: '',
    }
    const [serviceLineValidation, setServiceLineValidation] = useState([])
    console.log("serviceLineValidationmainServicelineModalProcedureCodeProcedureCode ", serviceLineValidation)

    const handleSuperSearchList = (selectedData, index, name, isRecCPT, method) => {
        if (!isSuperbillEditAllowed) return;
        console.log("firsthandleSuperSearchList", selectedData, index, name, isRecCPT, method)
        // debugger
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));
        // console.log("ProcedureCodeProcedureCode",selectedData)
        let data
        if (isRecCPT === true) {
            if (method === 'CPT') {
                data = { value: selectedData[0].ProcedureCodeID, display: selectedData[0].ProcedureCode }
            } else {
                data = { value: selectedData[0].ProcedureMacroID, display: selectedData[0].Name }
                // handleSelectIcdFromProcedureMacro(selectedData[0], index, method)
            }
        } else if (isRecCPT === 'Modifier') {
            data = { value: selectedData[0].ModifierCodeID, display: selectedData[0].ModifierCode }
        } else {
            if (!isNull(selectedData)) {
                selectedData.isUpdated = "true";
                data = selectedData;
            }
        }
        setIs(true)
        // let clas = document.getElementById('serviceLine')
        // clas.classList.add('ad-expand-table')
        let serviceLineItem = [...mainServiceLineModal];
        if (!isNull(data)) {
            console.log("ProcedureCodeProcedureCodedata", data)
            if (name === 'ProcedureCode') {
                let newItem;
                const existingItem = serviceLineItem?.find(it => it.ProcedureCodeID == String(data.value));

                if (existingItem) {
                    if (existingItem.Deleted === "true") {
                        // Deleted case: restore item
                        newItem = {
                            ...SERVICE_LINE_MODAL,
                            ProcedureCodeID: data.value + "",
                            [name]: data.display,          // latest UI update
                            SuperBillID: existingItem.SuperBillID || "",
                            // Keep any other fields you want to preserve from SERVICE_LINE_MODAL or existingItem
                            isUpdated: "true",
                        };

                        // Replace the deleted item in the array
                        const index = serviceLineItem.indexOf(existingItem);
                        if (index !== -1) serviceLineItem[index] = newItem;
                        console.log("Restored deleted item:", newItem);
                        // Update validation because item was restored
                        const newValidationlist = JSON.parse(JSON.stringify(serviceLineValidation));
                        newValidationlist.push(ServiceLineValidation_Modal);
                        setServiceLineValidation(newValidationlist);

                    }
                } else {
                    // Entirely new item → add to array
                    newItem = {
                        ...SERVICE_LINE_MODAL,
                        ProcedureCodeID: data.value + "",
                        [name]: data.display,
                        isUpdated: "true",
                    };
                    serviceLineItem.push(newItem);
                    // Update validation for the new item
                    const newValidationlist = JSON.parse(JSON.stringify(serviceLineValidation));
                    newValidationlist.push(ServiceLineValidation_Modal);
                    setServiceLineValidation(newValidationlist);
                }
                // serviceLineValidationCopy[index]['CPTCodeVal'] = ''
                if (method === 'CPT') {
                    // GetClaimTypeDD(data.value, index)
                }
            } else if (name === 'ModifierCode1') {
                serviceLineItem[index]['ModifierCodeID1'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;

            } else if (name === 'ModifierCode2') {
                serviceLineItem[index]['ModifierCodeID2'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'ModifierCode3') {
                serviceLineItem[index]['ModifierCodeID3'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'ModifierCode4') {
                serviceLineItem[index]['ModifierCodeID4'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'POSCode') {
                // serviceLineItem[index]['POSCodeID'] = data.value + ""
                // // serviceLineItem[index][name] = data.display
                // serviceLineItem[index]['POSCode'] = data.code + ""
                // serviceLineValidationCopy[index]['POSVal'] = ''

            } else if (name === 'RevenueCode') {
                // serviceLineItem[index]['RevenueCodeID'] = data.value + ""
                // serviceLineItem[index][name] = data.code
            }
        } else {
            console.log("ModifierCode1ModifierCode1", data, name)
            if (name === 'ModifierCode1') {
                serviceLineItem[index]['ModifierCodeID1'] = ""
                serviceLineItem[index][name] = '';

            } else if (name === 'ModifierCode2') {
                serviceLineItem[index]['ModifierCodeID2'] = ""
                serviceLineItem[index][name] = '';
            } else if (name === 'ModifierCode3') {
                serviceLineItem[index]['ModifierCodeID3'] = ""
                serviceLineItem[index][name] = '';
            } else if (name === 'ModifierCode4') {
                serviceLineItem[index]['ModifierCodeID4'] = ""
                serviceLineItem[index][name] = '';
            }
        }
        if (method === 'CPT') {
            setMainServiceLineModal(serviceLineItem)
            //   setServiceLineValidation(serviceLineValidationCopy)
        }
        if (isRecCPT === 'Modifier') {
            //   handleOnblurModifiers(data.value, name, index)
        }

    }

    const CPTValidation = () => {
        let allValid = true;
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));
        mainServiceLineModal.forEach((item, index) => {
            if (item?.Deleted === "true") {
                // Clear any old validation for deleted items
                serviceLineValidationCopy[index] = {};
                return;
            }
            if (!serviceLineValidationCopy[index]) {
                serviceLineValidationCopy[index] = {};
            }

            const pointerFields = ['Pointer1', 'Pointer2', 'Pointer3', 'Pointer4'];
            let pointerValues = pointerFields.map(p => (item[p] || "") + "");

            let uniqueSet = new Set();
            let hasDuplicates = false;
            let foundNull = false;
            let hasSequenceError = false;

            pointerFields.forEach((pointerName, i) => {
                const value = item[pointerName];
                const intValue = parseInt(value);
                const icdIndex = 'ICD' + value + 'Code';

                // ✅ Pointer1 Required check
                if (pointerName === 'Pointer1' && (isNull(value) || value === '')) {
                    serviceLineValidationCopy[index][pointerName + 'ICD'] = 'Pointer 1 is Required';
                    allValid = false;
                    return;
                }

                // Range check
                if ((intValue < 1 || intValue > 12) && !isNaN(intValue)) {
                    serviceLineValidationCopy[index][pointerName + 'ICD'] = 'Pointer value must be between 1 and 12';
                    allValid = false;
                } else if (icdIndex !== 'ICDCode') {
                    // Valid, clear any error
                    serviceLineValidationCopy[index][pointerName + 'ICD'] = '';
                }

                // Duplicate check
                if (!isNull(value)) {
                    if (uniqueSet.has(value)) {
                        hasDuplicates = true;
                    }
                    uniqueSet.add(value);
                }

                // Sequence check
                if (isNull(pointerValues[i])) {
                    foundNull = true;
                }
                if (!isNull(pointerValues[i]) && foundNull === true) {
                    hasSequenceError = true;
                }
            });

            serviceLineValidationCopy[index]['Pointer1UNI'] = hasDuplicates ? 'Pointers must be unique' : '';
            serviceLineValidationCopy[index]['Pointer1Val'] = hasSequenceError ? 'Pointers must be in sequence' : '';

            // Units Required check
            if (!item?.Units || isNaN(item?.Units) || parseFloat(item?.Units) <= 0) {
                serviceLineValidationCopy[index]['UnitsVal'] = 'Units Required';
                allValid = false;
            } else {
                serviceLineValidationCopy[index]['UnitsVal'] = '';
            }

            if (hasDuplicates || hasSequenceError) {
                allValid = false;
            }
        });

        setServiceLineValidation(serviceLineValidationCopy);

        let isNotValid = !allValid;
        if (isNotValid) {
            setIsProcedureEdit(true);
        }
        return isNotValid;
    };



    //    const CPTValidation = () => {
    //     let allValid = true;
    //     const newValidation = [];

    //     mainServiceLineModal.forEach((item, index) => {
    //         const validationItem = {};

    //         ['Pointer1', 'Pointer2', 'Pointer3', 'Pointer4'].forEach(pointerName => {
    //             const value = item[pointerName];

    //             // Call existing validation logic
    //             const result = handleOnblurServiceline(
    //                 { target: { value, name: pointerName } },
    //                 index
    //             );
    //             console.log("result",result)
    //             // Assume it returns true/false or updates state directly
    //             if (result === false) {
    //                 allValid = false;
    //             }

    //             // If handleOnblurServiceline updates state internally,
    //             // you may skip this block and instead read from serviceLineValidation after loop
    //         });

    //         newValidation.push(validationItem); // Optional if not setting custom messages here
    //     });

    //     // Optionally set newValidation if handleOnblurServiceline is *not* updating state
    //     // setServiceLineValidation(newValidation);

    //     return allValid;
    //     };



    useImperativeHandle(ref, () => ({
        CPTValidation
    }));

    const handleQualityOfCare = (e) => {
        let { name } = e.target;
        setQualityOfCareData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));

        setSaveQualityOfCareData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }
    let areAllValuesNullOrEmpty = (obj) => {
        console.log("CheckValidationobj", obj)
        for (let key in obj) {
            if (obj[key] !== null && obj[key] !== "") {
                return false;
            }
        }
        return true;
    }
    const handleDeleteRow = (index) => {
        console.log("indexindexindexindex", index, mainServiceLineModal)
        const data = [...mainServiceLineModal];
        const validationList = [...serviceLineValidation];

        if (!data[index]?.SuperBillID) {
            // Hard delete → remove row & validation
            data.splice(index, 1);
            validationList.splice(index, 1);
        } else {
            // Soft delete → mark deleted & updated
            data[index].Deleted = "true";
            data[index].isUpdated = "true";
            // Optionally mark the corresponding validation entry as deleted
            if (validationList[index]) {
                validationList[index] = JSON.parse(JSON.stringify(ServiceLineValidation_Modal));
            }
        }
        setMainServiceLineModal(data);
        setServiceLineValidation(validationList);
    };
    const handleViewClaim = () => {
        if (!isClaimViewAllowed) return;
        let obj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                id: initialData.Data.ClaimID,
                name: initialData.Data.PatientName,
                time: new Date(),
                visitType: initialData.Data?.ClaimType,
                EncounterID: initialData?.Data?.EncounterID,
                PatientID: initialData?.Data?.PatientID,
            },
        };
        setOpenTab(obj)
    }
    const handleCreateClaim = () => {
        if (!isCreateClaimEditAllowed) return;
        let dataForClaim = {
            EncounterID: initialData?.Data?.EncounterID,
            PatientID: initialData?.Data?.PatientID,
            PatientName: initialData?.Data?.PatientName,
        }
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Professional",
                id: -1,
                time: new Date(),
                visitType: "P",
                EncounterID: dataForClaim
            },
        };
        setOpenTab(dataObj)
    }

    const [isOpenProcedure, setisOpenProcedure] = useState(false)
    const [ActiveCode, setActiveCode] = useState('')
    const [ActiveCodeindex, setActiveCodeindex] = useState('')
    const [ActiveCodeName, setActiveCodeName] = useState('')

    const handleAddNewCPT = (searchValue, name, index) => {
        if (!isNull(searchValue)) {
            setActiveCode(searchValue)
            // setActiveCodeindex(index)
        } else {
            setActiveCode('')
        }
        setisOpenProcedure(true)
    }
    const handleCloseCPT = () => {
        setisOpenProcedure(false)
    }
    const handleClearState = () => {
        setActiveCode('')
        // setActiveCodeindex()
        setActiveCodeName('')
    }
    const handleOnSaveCPT = (selectedData) => {
        // handleSuperSearchList(selectedData, ActiveCodeindex, 'ProcedureCode', false, 'CPT')
        handleSuperSearchList(selectedData, 'index', 'ProcedureCode', false, 'CPT')
        handleClearState();
    }
    let ProcedurePopup = ''
    if (isOpenProcedure) {
        ProcedurePopup = <AddNewProcedureCodes isOpenProcedure={isOpenProcedure} onClose={handleCloseCPT} ProcedureCode={ActiveCode} onDeleteProcedure={handleCloseCPT} handleOnSaveICD={handleOnSaveCPT} isOpenFromList={true} />
    }
    ////////////// Problems ///////////////
    const [lastEncounterProblems, setLastEncounterProblems] = useState({})

    const LoadLastEncounterProblem = () => {
        if (!searchParam?.EncounterDate) return;
        setLastEncounterProblems({})
        ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.EncounterProblem,
            "ID": patientID,
            "SearchCriteria": {
                "EncounterDate": searchParam.EncounterDate
            }
        })
            .then((response) => {
                setLastEncounterProblems({
                    EncounterDate: response?.count?.EncounterDate,
                    Problems: response?.Rows || []
                });
                // setPastVitalsLoaded(true);
            }).catch((error) => {
                // setIsLoading(false)
            })
    }
    ////////////// CPT ///////////////
    const [lastEncounterCPTs, setLastEncounterCPTs] = useState({})

    const LoadLastEncounterCPT = () => {
        if (!searchParam?.EncounterDate) return;
        setLastEncounterCPTs({})
        ServerRequestProtected(API_URL_PATIENTENCOUNTER + "/LastEncounterCPT", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": patientID,
            "SearchCriteria": {
                "EncounterDate": searchParam.EncounterDate
            }
        })
            .then((response) => {
                setLastEncounterCPTs({
                    EncounterDate: response?.count?.EncounterDate,
                    CPTs: response?.Rows || []
                });
                // setPastVitalsLoaded(true);
            }).catch((error) => {
                // setIsLoading(false)
            })
    }

    const handleApplyProblems = () => {
        const getNewProblems = (existingList = [], type) => {
            const existingCodes = new Set(existingList.map(prob => prob.DiagnosisCode));
            console.log("LEP lastEncounterProblems 0", existingCodes);
            console.log("LEP lastEncounterProblems 1", lastEncounterProblems);
            let updatedArr = (lastEncounterProblems?.Problems || []).filter(prob => !existingCodes.has(prob.DiagnosisCode)).map(({ EncounterID, ...it }) => (it));
            //  FIX Deleted and Added existing record before saving ====////===== Case HERE
            updatedArr = updatedArr.map(prob => {
                const prevItem = existingList.find(x => x.DiagnosisCode === prob.DiagnosisCode);
                if (prevItem) {
                    // If it was deleted → restore Deleted flag
                    const restoredItem = prevItem.Deleted === "true" ? { ...prevItem, Deleted: "false" } : prevItem;
                    // Merge IDs from prevItem but keep latest fields from prob
                    return {
                        ...prob, // latest fields
                        // EncounterID: restoredItem.EncounterID,
                        EncounterProblemID: restoredItem.EncounterProblemID,
                        PatientProblemListID: restoredItem.PatientProblemListID,
                        Deleted: restoredItem.Deleted // keep restored Deleted if applicable
                    };
                }

                return prob;
            });
            console.log("LEP lastEncounterProblems 2", updatedArr);

            if (type === 'Save') {
                let viewExistingCodes = new Set((assessmentData?.EncounterProblem || []).map(prob => prob.DiagnosisCode));
                updatedArr = updatedArr.map(prob => {
                    if (viewExistingCodes.has(prob.DiagnosisCode)) {
                        let viewItem = assessmentData.EncounterProblem.find(assessProb => prob.DiagnosisCode === assessProb.DiagnosisCode)
                        return {
                            ...prob,
                            EncounterID: viewItem.EncounterID,
                            EncounterProblemID: viewItem.EncounterProblemID,
                            PatientProblemListID: viewItem.PatientProblemListID
                        };
                    } else {
                        return prob;
                    }
                })
            }
            return updatedArr;
        };


        setSaveProblemsData(prev => {
            let saveExisting = [...getNewProblems(prev, 'Save')];
            const newProbs = [...prev, ...saveExisting];
            return newProbs;
        });

        setAssessmentData(prev => {
            const existingList = prev?.EncounterProblem || [];
            const newProbs = [...existingList, ...getNewProblems(existingList, 'View')];
            return {
                ...prev,
                EncounterProblem: newProbs
            };
        });
    };

    const handleApplyCPTs = () => {
        if (!isSuperbillEditAllowed) return;

        const existingCodes = new Set(mainServiceLineModal.map(prob => prob.ProcedureCodeID));
        let newValidationList = [...serviceLineValidation];

        let restoredItems = [];
        let untouchedItems = [];

        // Split existing rows into restored vs untouched
        mainServiceLineModal.forEach(item => {
            const replacement = (lastEncounterCPTs?.CPTs || []).find(
                prob => item.ProcedureCodeID == prob.ProcedureCodeID
            );

            if (item.Deleted === "true" && replacement) {
                // Restore deleted item using replacement fields
                let { EncounterID, EncounterDate, Description, Deleted, ...rest } = replacement;
                console.log("replacement11", replacement)
                restoredItems.push({
                    ...rest,
                    isUpdated: "true",
                    Deleted: "false",
                    SuperBillID: item.SuperBillID,   // KEEP original SuperBillID
                });

                // Add validation ONLY for restored row
                newValidationList.push(ServiceLineValidation_Modal);

            } else {
                // Keep normal items in order
                untouchedItems.push(item);
            }
        });

        // NEW CPTs (not in modal)
        const newCPTs = (lastEncounterCPTs?.CPTs || [])
            .filter(prob => !existingCodes.has(prob.ProcedureCodeID))
            .map(cpt => {
                let { EncounterID, EncounterDate, Description, Deleted, ...rest } = cpt;
                rest["isUpdated"] = "true";

                // Add validation for truly new items
                newValidationList.push(ServiceLineValidation_Modal);

                return rest;
            });

        // Final ordering:
        // 1. Untouched items stay where they are
        // 2. Restored items move to the end
        // 3. Newly added CPTs come after restored
        const finalList = [
            ...untouchedItems,
            ...restoredItems,
            ...newCPTs
        ];

        setMainServiceLineModal(finalList);
        setServiceLineValidation(newValidationList);
    };

    const { insertPosition } = props;
    const mainNavigationKeywordList = (mainCustomTemplateData?.[0]?.Data?.[0]?.items || [])?.map((item) => item.NavigationKeyword || 'MCT'); 
    const customNavigationKeywordList = (props?.customTemplateData?.[0]?.Data?.[0]?.items || [])?.map((item) => item.NavigationKeyword || 'CT'); 
 
    // Custom (Top/Bottom) templates: flatten across the WHOLE array in original order,
    // keeping (templateIndex, itemIndex) pairs so ref IDs stay deterministic and line up
    // with what CustomTemplateForm generates per item.
    const customTemplateNavEntries = (props?.customTemplateData || []).flatMap((template, templateIndex) =>
        (template?.Data?.[0]?.items || []).map((item, itemIndex) => ({
            templateIndex,
            itemIndex,
            navigationKeyword: item.NavigationKeyword || 'CT',
        }))
    );
    const scrollNavIDs = useMemo(() => {
        const id = encounterID || '';
        return {
            refMCF: `ref-MCF${id}`,
            ...Object.fromEntries(
                (mainNavigationKeywordList || []).map((_, index) => [
                    `refMCF${id}0_${index}`, // template index fixed at 0 — MainCustomTemplate is single-item
                    `ref-MCF${id}-0-${index}`,
                ])
            ),
            // One ref per (template, item) pair across all custom templates
            ...Object.fromEntries(
                customTemplateNavEntries.map(({ templateIndex, itemIndex }) => [
                    `refCF${id}${templateIndex}_${itemIndex}`,
                    `ref-CF${id}-${templateIndex}-${itemIndex}`,
                ])
            ),
            // One ref per template "card" — used for the wrapping div's hover/click/scroll target,
            // and for auto-scrolling to a newly imported template.
            ...Object.fromEntries(
                (props?.customTemplateData || []).map((_, templateIndex) => [
                    `refCF${id}_card_${templateIndex}`,
                    `ref-CF${id}-card-${templateIndex}`,
                ])
            ),
        };
    }, [encounterID, customTemplateNavEntries, props?.customTemplateData?.length, mainNavigationKeywordList]);

    /////////////Navigate to newly added custom template on import //////////////
    const handleNavigateToCustomTemplate = (id) => {
        // props?.setActiveID(id);
        const elementBar = document?.getElementById(`${id}`);
        if (elementBar) {
            elementBar.scrollIntoView({ behavior: 'smooth' });
        }
    }

    useEffect(() => {
        const templates = props?.customTemplateData || [];
        if (templates.length === 0 || props?.saveCustomTemplateData?.length === 0) return;
        // customTemplateData is append-only on import (Step 1), so the most recently
        // added template is always the last element.
        const lastIndex = templates.length - 1;
        const refId = scrollNavIDs?.[`refCF${encounterID || ''}_card_${lastIndex}`];
        if (refId) handleNavigateToCustomTemplate(refId);
    }, [props?.customTemplateData?.length])
    /////////////////////////////////////////////////////////////////////////////
    const ASAM_LABELS = {
        // Dimension 1
        addiction_medications: "Are you using any medications for withdrawals or cravings?",
        sobriety_from_doc: "How long have you been sober from your DOC?",
        sobriety_from_all_substances: "How long have you been sober from all substances?",
        current_withdrawal_symptoms: "Are you currently experiencing any withdrawal symptoms such as tremors, sweating, rapid heart rate, anxiety, nausea, etc?",
        history_of_severe_withdrawal: "Do you have a history of serious withdrawals such as seizures, or anything else health-threatening?",
        history_of_overdose: "Do you have a history of overdose? When was the last time you overdosed?",

        // Dimension 2
        primary_care_and_medical_visits: "Do you have a primary doctor? When was the last time you saw a medical provider?",
        medications_and_adherence: "Are you currently taking any medications? Are you taking them as prescribed?",
        medical_conditions_affecting_treatment: "Do you have any known medical conditions at this time, particularly any that could be a distraction from treatment?",
        pregnancy_or_sleep_concerns: "Any issues with pregnancy or sleep that need immediate attention?",
        physical_health_goals: "What goals do you have for your physical health or medical conditions? What changes could you start making to make this possible for you?",

        // Dimension 3
        self_harm_history: "Do you have any history of self harm? When was the last time? What was it?",
        mental_health_treatment_history: "Have you previously received treatment for mental health or emotional problems? When was the last time?",
        depression_anxiety_ptsd_symptoms: "Assess depression and anxiety and PTSD with scales. Currently/last seven days. Does it stay pretty consistent?",
        coping_skills_and_supports: "What helps you cope with your anxiety and/or depression/PTSD?",
        psychosis_or_cognitive_symptoms: "Are you experiencing any current psychosis such as paranoia, delusions, or any confusion?",
        suicidal_ideation_history: "Do you have any history of suicidal ideations? When was the last time?",
        recent_thoughts_of_death_or_hopelessness: "Have you had thoughts that you would be better off dead in the last 30 days?",
        mental_health_medications: "Are you currently taking any medications for your mental health? What are they for?",

        // Dimension 4
        awareness_of_substance_use_impact: "Do you think you need treatment to change your use of substances?",
        belief_in_need_for_treatment: "Do you believe changing your use of substances could improve any aspects of your life? Which ones?",
        past_treatment_effectiveness: "How helpful has treatment been in the past?",
        desire_to_quit_or_reduce_use: "Do you want to quit or cut back your alcohol or other drug use?",

        // Dimension 5
        factors_supporting_sobriety: "What helped you go that long without using alcohol and/or other drugs?",
        support_system: "Who makes up your support system?",
        current_cravings_level: "Current Cravings 0-10, 10 being the highest",
        sobriety_duration_longest_period: "What is the longest period of time that you have gone without using alcohol and/or other drugs?",
        environmental_relatapse_factors: "If you relapsed in the past, what environmental things led to your relapse?",
        recent_triggers_or_stressors: "Which trigger(s) or problem(s) have been the worst for you in the past month or so?",
        safety_of_current_relationships: "Do any of your current relationships pose a threat to your safety or recovery?",
        potential_risks_if_no_treatment: "What problems could happen or get worse if you do not get help now?",

        // Dimension 6
        housing_stability: "In the past two months, have you been living in stable housing that you own, rent, or stay in as part of a household?",
        financial_stability: "What are the sources of your financial support?",
        supportive_individuals: "Are these sources providing you with financial stability?",
        clinical_justification: "Clinical Justification",
        future_housing_concerns: "Are you worried or concerned that in the next two months you may NOT have stable housing that you own, rent, or stay in as part of a household?",
        employment_or_education_status: "Are you working/going to school/retired/disabled/unemployed?",
        financial_support_sources: "Who else in your life cares whether you quit or not?",
        barriers_to_treatment: "Do you have any concerns or fears that make it hard for you to stay in treatment?",
        leisure_and_free_time: "How do you prefer to spend your free time (e.g., when not working)?",
        desired_environment_changes: "If things improved in your environment, what would that look like?",
        environment_goals: "What are your top environment goals? This might include getting a job, going back to school, getting social services, etc.",
        recommended_level_of_care: "Clinically Recommended Level of Care Based on Above Assessment",
    };
    // Reverse the ASAM_LABELS map: question text → key
    const ASAM_LABELS_REVERSED = Object.entries(ASAM_LABELS).reduce((acc, [key, question]) => {
        acc[question.toLowerCase().trim()] = key;
        return acc;
    }, {});
    // Flatten AI response into { key: value } — handles nested objects
    const flattenASAMResponse = (asamData) => {
        const flat = {};
        if (!asamData || typeof asamData !== 'object') return flat;

        Object.values(asamData).forEach(dimension => {
            if (typeof dimension !== 'object') return;
            Object.values(dimension).forEach(section => {
                if (typeof section !== 'object') return;
                Object.entries(section).forEach(([key, value]) => {
                    if (key === 'severity_score') {
                        // ✅ Handle severity_score as object or string
                        flat[key] = typeof value === 'object'
                            ? `Score: ${value.score} — ${value.justification}`
                            : value;
                    } else {
                        flat[key] = typeof value === 'string' ? value : JSON.stringify(value);
                    }
                });
            });
        });

        return flat;
    };
    // ✅ Extract selected option from selectedOptions string
    // e.g. "Score 2 (Moderate): ...(D)[TR=false...]" → "Score 2 (Moderate): ..."
    const extractSelectedOption = (selectedOptions) => {
        if (!selectedOptions) return '';
        const parts = selectedOptions.split('||SEP||');
        const selected = parts.find(p => p.includes('(D)'));
        if (!selected) return '';
        // Clean up the option text
        return selected
            .replace('(D)', '')
            .replace(/\[TR=.*?\]/g, '')
            .trim();
    };
    const updateTemplateWithASAMResponse = (templateData, asamResponse) => {
        if (!Array.isArray(templateData) || !asamResponse) return templateData;

        const flatResponse = flattenASAMResponse(asamResponse);

        const severityScores = [];
        Object.values(asamResponse).forEach(dimension => {
            if (typeof dimension !== 'object') return;
            Object.values(dimension).forEach(section => {
                if (typeof section !== 'object') return;
                if (section.severity_score !== undefined) {
                    const score = typeof section.severity_score === 'object'
                        ? section.severity_score.score
                        : section.severity_score;
                    severityScores.push(String(score).toLowerCase().trim());
                }
            });
        });

        let severityIndex = 0;

        return templateData.map(form => ({
            ...form,
            Data: form.Data.map(component => ({
                ...component,
                items: component.items.map(item => {

                    // ✅ Simple Question — update answer ONLY
                    if (item.name === 'Simple Question') {
                        const normalizedContent = item.content?.toLowerCase().trim();
                        const matchedKey = ASAM_LABELS_REVERSED[normalizedContent];
                        if (matchedKey && flatResponse[matchedKey] !== undefined) {
                            return {
                                ...item,
                                answer: flatResponse[matchedKey]
                                // ✅ selectedOptions not touched
                            };
                        }
                        return item;
                    }

                    // ✅ Single Choice — update selectedOptions ONLY
                    if (item.name === 'Single Choice') {

                        // Severity Score
                        if (item.content === 'Severity Score') {
                            const aiScore = severityScores[severityIndex] || '';
                            severityIndex++;
                            if (!aiScore || !item.options) return item;

                            const updatedSelectedOptions = item.options
                                .split('||SEP||')
                                .map(option => {
                                    const cleanOption = option
                                        .replace(/\[TR=.*?\]/g, '')
                                        .replace('(D)', '')
                                        .trim()
                                        .toLowerCase();

                                    const isMatch =
                                        cleanOption.includes(aiScore) ||
                                        (aiScore.includes('low') && cleanOption.includes('low')) ||
                                        (aiScore.includes('moderate') && cleanOption.includes('moderate')) ||
                                        (aiScore.includes('high') && cleanOption.includes('high')) ||
                                        (aiScore.includes('3') && cleanOption.includes('score 3')) ||
                                        (aiScore.includes('2') && cleanOption.includes('score 2')) ||
                                        ((aiScore === '0-1' || aiScore === '0–1') && cleanOption.includes('score 0'));

                                    if (isMatch) {
                                        return option.replace(/\[TR=.*?\]/, match => `(D)${match}`);
                                    }
                                    return option.replace('(D)', '');
                                })
                                .join('||SEP||');

                            return {
                                ...item,
                                selectedOptions: updatedSelectedOptions
                                // ✅ answer not touched
                            };
                        }

                        // Level of Care
                        if (item.content === 'Clinically Recommended Level of Care Based on Above Assessment') {
                            const aiLevelOfCare = flatResponse['recommended_level_of_care']?.toLowerCase().trim();
                            if (!aiLevelOfCare || !item.options) return item;

                            const updatedSelectedOptions = item.options
                                .split('||SEP||')
                                .map(option => {
                                    const cleanOption = option
                                        .replace(/\[TR=.*?\]/g, '')
                                        .replace('(D)', '')
                                        .trim()
                                        .toLowerCase();

                                    const isMatch =
                                        cleanOption.includes(aiLevelOfCare) ||
                                        aiLevelOfCare.includes(cleanOption);

                                    if (isMatch) {
                                        return option.replace(/\[TR=.*?\]/, match => `(D)${match}`);
                                    }
                                    return option.replace('(D)', '');
                                })
                                .join('||SEP||');

                            return {
                                ...item,
                                selectedOptions: updatedSelectedOptions
                                // ✅ answer not touched
                            };
                        }

                        // Current Cravings
                        if (item.content === 'Current Cravings 0-10, 10 being the highest') {
                            const aiCravings = flatResponse['current_cravings_level']?.trim();
                            if (!aiCravings || !item.options) return item;

                            const updatedSelectedOptions = item.options
                                .split('||SEP||')
                                .map(option => {
                                    const cleanOption = option
                                        .replace(/\[TR=.*?\]/g, '')
                                        .replace('(D)', '')
                                        .trim();

                                    const isMatch =
                                        cleanOption === aiCravings ||
                                        aiCravings.startsWith(cleanOption);

                                    if (isMatch) {
                                        return option.replace(/\[TR=.*?\]/, match => `(D)${match}`);
                                    }
                                    return option.replace('(D)', '');
                                })
                                .join('||SEP||');

                            return {
                                ...item,
                                selectedOptions: updatedSelectedOptions
                                // ✅ answer not touched
                            };
                        }

                        return item;
                    }

                    return item;
                })
            }))
        }));
    };
    const NOTE_TYPE_LABELS = {
        data: "data",
        assessment: "assessment",
        progress: "progress",
        plan: "plan",
    };

    const updateTemplateWithNoteResponse = (templateData, noteResponse) => {
        if (!Array.isArray(templateData) || !noteResponse) return templateData;

        return templateData.map(form => ({
            ...form,
            Data: form.Data.map(component => ({
                ...component,
                items: component.items.map(item => {
                    if (item.name !== 'Simple Question') return item;

                    // ✅ Normalize item content to match keys
                    // "Data" → "data", "Assessment" → "assessment" etc.
                    const normalizedContent = item.content?.toLowerCase().trim();

                    // ✅ Check if content matches any key in noteResponse
                    const matchedKey = Object.keys(noteResponse).find(key =>
                        normalizedContent === key.toLowerCase() ||
                        normalizedContent.startsWith(key.toLowerCase())
                    );

                    if (matchedKey && noteResponse[matchedKey] !== undefined) {
                        return {
                            ...item,
                            answer: noteResponse[matchedKey] || ''
                        };
                    }

                    return item;
                })
            }))
        }));
    };
    useEffect(() => {
        if (!isNull(aiEncounterData)) {
            // setSubjectiveData(prev => ({
            //     ...prev, "SubjectiveNotes": aiEncounterData?.subjective || ''
            // }));
            // setObjectiveData(prev => ({
            //     ...prev, "ObjectiveNotes": aiEncounterData?.objective || ''
            // }));
            // setAssessmentData(prev => ({
            //     ...prev, "ResponseNotes": aiEncounterData?.assessment || ''
            // }));
            // setPlanData(prev => ({
            //     ...prev, "PlanNotes": aiEncounterData?.plan?.display || ''
            // }));
            if (aiEncounterData && mainCustomTemplateData) {
                // setSaveMainCustomTemplateData(aiEncounterData?.MainCustomTemplate || []);
                // props?.setSaveCustomTemplateData(aiEncounterData?.CustomTemplate || []);

                // setMainServiceLineModal(aiEncounterData?.SuperBill)
                // setSaveHPIData({"HistoryOfPresentIllnessID": "", ...aiEncounterData?.HistoryOfPresentIllness })
                // setSaveROSData({"ReviewOfSystemID": "", ...aiEncounterData?.ReviewOfSystem });
                // setSaveProblemsData(aiEncounterData?.EncounterProblem);
                // setSaveDocumentData(aiEncounterData?.EncounterDocument);
                // setSaveQualityOfCareData(aiEncounterData?.QualityOfCare);
                // setVitalData(aiEncounterData?.Vital);
                if (aiEncounterData?.MainCustomTemplate) {
                    setSaveMainCustomTemplateData(aiEncounterData.MainCustomTemplate);
                }
                if (aiEncounterData?.CustomTemplate) {
                    props?.setSaveCustomTemplateData(aiEncounterData.CustomTemplate);
                }
                console.log("aiEncounterData", aiEncounterData)
                if (aiEncounterData?.SuperBill) {
                    setMainServiceLineModal(aiEncounterData.SuperBill);
                }
                if (aiEncounterData?.HistoryOfPresentIllness) {
                    setSaveHPIData({"HistoryOfPresentIllnessID": "", ...aiEncounterData?.HistoryOfPresentIllness })
                }
                if (aiEncounterData?.ReviewOfSystem) {
                    setSaveROSData({"ReviewOfSystemID": "", ...aiEncounterData?.ReviewOfSystem });
                }
                if (aiEncounterData?.EncounterProblem) {
                    setSaveProblemsData(aiEncounterData.EncounterProblem);
                }
                if (aiEncounterData?.EncounterDocument) {
                    setSaveDocumentData(aiEncounterData.EncounterDocument);
                }
                if (aiEncounterData?.QualityOfCare) {
                    setSaveQualityOfCareData(aiEncounterData?.QualityOfCare);
                }
                if (aiEncounterData?.Vital) {
                    setVitalData(aiEncounterData.Vital);
                }
                
                props?.handleSetResponse(aiEncounterData);

                console.log("ToSaveDataAI", aiEncounterData)
                // // ✅ Update template answers with AI response
                // if (initialData?.Data?.NoteType === 'ASAM') {
                //     const updatedTemplate = updateTemplateWithASAMResponse(
                //         mainCustomTemplateData,
                //         aiEncounterData
                //     );
                //     setMainCustomTemplateData(updatedTemplate);
                //     setSaveMainCustomTemplateData(updatedTemplate)
                // } else if (aiEncounterData?.data || aiEncounterData?.assessment) {
                //     const updatedTemplate = updateTemplateWithNoteResponse(
                //         mainCustomTemplateData,
                //         aiEncounterData
                //     );
                //     setMainCustomTemplateData(updatedTemplate);
                //     setSaveMainCustomTemplateData(updatedTemplate)
                // }
            }
        }
    }, [aiEncounterData])
    
    const sharedWidgetUtilities = {
        //Chief Complaint
        subjectiveData,
        setSubjectiveData,

        handleChange: handleChange,
        // Problems
        assessmentData,
        setAssessmentData,
        saveProblemsData,
        setSaveProblemsData,
        PatDxData,
        AddProblems,
        selectedDiagnosisValue,
        setSelectedDiagnosisValue,
        searchParam,
        patientID,
        API_URL,
        RecentICDs,
        IsEditAllowed,
        IsDeleteAllowed,
        handleAddNewICD,
        // Vitals
        setSearchParam,
        vitalData, setVitalData,
        vitalsPastData, setVitalsPastData,
        pastVitalsLoaded, setPastVitalsLoaded,
        LoadDD,

        initialDataChiefComplaint: initialData?.Data?.ChiefComplaint,
        initialDataVital: initialData?.Vital,
        initialDataCognitiveStatus: initialData?.CognitiveStatus,
        initialDataFunctionalStatus: initialData?.FunctionalStatus,
        initialDataEncounterID: initialData?.Data?.EncounterID,

        //HPI
        initialDataPatientName: initialData?.Data?.PatientName,
        initialDataAge: initialData?.Data?.Age,
        initialDataDOB: initialData?.Data?.DOB,
        initialDataAddress: initialData?.Data?.Address,
        initialDataMobileNumber: initialData?.Data?.MobileNumber,
        initialDataEmail: initialData?.Data?.Email,
        setSaveHPIData,

        //ROS
        setSaveROSData,

        //Follow Up
        planData,
        setPlanData,

        // Additional Info
        additionalInfoData,
        setAdditionalInfoData,
        AddDocument,
        setSaveDocumentData,

        // Quality Of Care
        qualityOfCareData,
        setQualityOfCareData,
        setSaveQualityOfCareData,

        // Procedure Codes
        mainServiceLineModal,
        setMainServiceLineModal,
        serviceLineValidation,
        setServiceLineValidation,
        CPTModal,
        setCPTModal,
        cptBody,
        setcptBody,
        modifierBody,
        setmodifierBody,
        lastEncounterCPTs,
        RecentCPTs,
        RecentModifiers,
        isSuperbillEditAllowed,
        isClaimViewAllowed,
        isCreateClaimEditAllowed,
        dataExist,
        divClaimLinking,
        handleViewClaim,
        handleCreateClaim,
        handleApplyCPTs,
        handleAddNewCPT,
        areAllValuesNullOrEmpty,
        initialDataClaimID: initialData?.Data?.ClaimID,
        isProcedureEdit, setIsProcedureEdit,
    };
    // Pair each custom template with its REAL position in the full array before
    // filtering — CustomTemplateForm's `index` prop must always refer to the full
    // array, never to position within a filtered Top/Bottom subgroup.
    const indexedCustomTemplates = (props?.customTemplateData || [])
        .map((item, originalIndex) => ({ item, originalIndex }));
    // PlacementIndex is not set yet but can be utilized in future to set its Placement, right now we will add it to last index
    const sortByPlacement = (a, b) => (a.item.PlacementIndex ?? a.originalIndex) - (b.item.PlacementIndex ?? b.originalIndex);

    const topCustomTemplates = indexedCustomTemplates
        .filter(({ item }) => item.InsertPosition === 'Top')
        .sort(sortByPlacement);

    const bottomCustomTemplates = indexedCustomTemplates
        .filter(({ item }) => item.InsertPosition !== 'Top') // default bucket
        .sort(sortByPlacement);

    // console.log("CustomTemplateData2312 main", indexedCustomTemplates)
    // console.log("CustomTemplateData2312 TopBottom", topCustomTemplates, bottomCustomTemplates)
    // console.log("CustomTemplateData231 main", props?.customTemplateData)
    // console.log("CustomTemplateData231 saveCustomTemplateData", props?.saveCustomTemplateData)
    return (
        <>
            {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
            {ProcedurePopup}
            {PopupScreenDocument}
            {showPreview ?
                <EncounterPreview data={initialData} searchParam={searchParam} setSearchParam={setSearchParam} searchValue={searchValue}

                    mainServiceLineModal={mainServiceLineModal}
                    setMainServiceLineModal={setMainServiceLineModal}
                    serviceLineValidation={serviceLineValidation}
                    handleOnblurServiceline={handleOnblurServiceline}
                    handleServiceLineChange={handleServiceLineChange}
                    handleDeleteRow={handleDeleteRow}
                    modifierBody={modifierBody}
                    handleSuperSearchList={handleSuperSearchList}
                    handleApplyCPTs={handleApplyCPTs}
                    isProcedureEdit={isProcedureEdit}
                    CPTModal={CPTModal}
                    cptBody={cptBody}
                    RecentModifiers={RecentModifiers}
                    // RecentCPTs={RecentCPTs}
                    areAllValuesNullOrEmpty={areAllValuesNullOrEmpty}
                    handleCreateClaim={handleCreateClaim}
                    handleViewClaim={handleViewClaim}
                    handleEditProcedure={handleEditProcedure}
                    handleAddNewCPT={handleAddNewCPT}
                    mainServiceLineModalSaveData={mainServiceLineModalSaveData}
                    //////////////////////Additional Info//////////////////////
                    initialDataPatientName= {initialData?.Data?.PatientName}
                    initialDataAge= {initialData?.Data?.Age}
                    initialDataDOB= {initialData?.Data?.DOB}
                    initialDataAddress= {initialData?.Data?.Address}
                    initialDataMobileNumber= {initialData?.Data?.MobileNumber}
                    initialDataEmail= {initialData?.Data?.Email}
                    initialDataEncounterStatus= {initialData?.Data?.EncounterStatus}
                    additionalInfoData={additionalInfoData} 
                    setAdditionalInfoData={setAdditionalInfoData}
                    AddDocument={AddDocument}
                    setSaveDocumentData={setSaveDocumentData}
                    ///////////////////////////////////////////////////////////
                    getSaveData={props?.getSaveData}
                    patientID={patientID}
                    encounterID={encounterID}
                    setReloadAfterSave={props?.setReloadAfterSave}
                    defaultSelectedItems={defaultSelectedItems}
                    Data={
                        {
                            ...(subjectiveData || {}),
                            "HistoryOfPresentIllness": subjectiveData?.HistoryOfPresentIllness,
                            "ReviewOfSystem": subjectiveData?.ReviewOfSystem,
                            "PrescriptionsNotes": planData?.PrescriptionsNotes || "",
                            "SupplementsNotes": planData?.SupplementsNotes || "",
                            "VaccinesNotes": planData?.VaccinesNotes || "",
                            "InjectionsNotes": planData?.InjectionsNotes || "",
                            "LabsNotes": planData?.LabsNotes || "",
                            "ImagingNotes": planData?.ImagingNotes || "",
                            "PlanNotes": planData?.PlanNotes,
                            "FollowUpDate": planData?.FollowUpDate || "",
                            "FollowUpNotes": planData?.FollowUpNotes || "",
                            "EncounterProblem": assessmentData?.EncounterProblem,
                            "EncounterDocument": additionalInfoData?.EncounterDocument,
                            "QualityOfCare": qualityOfCareData,
                            "BehaviourNotes": objectiveData?.BehaviourNotes,
                            "InterventionNotes": interventionData.InterventionNotes,
                            "ResponseNotes": assessmentData?.ResponseNotes,
                            "AdditionalInfoNotes": additionalInfoData?.AdditionalInfoNotes,
                            "CustomTemplateData": props?.customTemplateData,
                            "MainCustomTemplateData": props?.mainCustomTemplateData,

                            "vitalData": vitalData,
                            "HistoryOfPresentIllness": subjectiveData?.HistoryOfPresentIllness,
                            "ReviewOfSystem": subjectiveData?.ReviewOfSystem,
                        }} /> :
                <div className="d-flex flex-column gap-10">
                    <SignEncounter isSign={isSign} setIsSign={setIsSign} providerName={initialData?.Data?.ProviderName || ''} setSearchParam={setSearchParam}
                        getSaveData={props?.getSaveData} initialDataData={initialData?.Data || {}} />
                    {PopupScreenProblems}
                    {/* {PopupScreenDocument} */}
                    {PopupNewICD}

                    {topCustomTemplates.map(({ item, originalIndex }) => {
                        const cardRefId = scrollNavIDs?.[`refCF${encounterID || ''}_card_${originalIndex}`];
                        return (
                            <div key={item.ClientTemplateID || item.PatientIntakeFormID || originalIndex}
                                id={cardRefId}
                                onMouseEnter={() => handleHoveredItem(cardRefId)}
                                onClick={() => handleActiveItem(cardRefId)}>
                                <CustomTemplateForm
                                    index={originalIndex}
                                    customTemplateData={props?.customTemplateData}
                                    setCustomTemplateData={props?.setCustomTemplateData}
                                    setSaveCustomTemplateData={props?.setSaveCustomTemplateData}
                                    validations={props?.validations}
                                    itemsCollapsed={itemsCollapsed}
                                    handleItemsExpanded={handleItemsExpanded}
                                    widgetUtilities={sharedWidgetUtilities}
                                    scrollNavUtilities={{ scrollNavIDs, handleHoveredItem, handleActiveItem, encounterID }}
                                />
                            </div>
                        );
                    })}
                    {props?.mainCustomTemplateData?.length > 0 &&
                        <div className="" id={scrollNavIDs.refMCF} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refMCF)} onClick={() => handleActiveItem(scrollNavIDs.refMCF)}>
                            <CustomTemplateForm CustomTemplateFormType={'MainCustomTemplate'} customTemplateData={props?.mainCustomTemplateData} setCustomTemplateData={props?.setMainCustomTemplateData} setSaveCustomTemplateData={props?.setSaveMainCustomTemplateData} validations={props?.validationItemsModalMain} itemsCollapsed={itemsCollapsed} handleItemsExpanded={handleItemsExpanded} isCustomNote={"true"} widgetUtilities={sharedWidgetUtilities} 
                            scrollNavUtilities={{scrollNavIDs, handleHoveredItem ,handleActiveItem, encounterID}}
                            />
                        </div>
                    }
                    {bottomCustomTemplates.map(({ item, originalIndex }) => {
                        const cardRefId = scrollNavIDs?.[`refCF${encounterID || ''}_card_${originalIndex}`];
                        return (
                            <div key={item.ClientTemplateID || item.PatientIntakeFormID || originalIndex}
                                id={cardRefId}
                                onMouseEnter={() => handleHoveredItem(cardRefId)}
                                onClick={() => handleActiveItem(cardRefId)}>
                                <CustomTemplateForm
                                    index={originalIndex}
                                    customTemplateData={props?.customTemplateData}
                                    setCustomTemplateData={props?.setCustomTemplateData}
                                    setSaveCustomTemplateData={props?.setSaveCustomTemplateData}
                                    validations={props?.validations}
                                    itemsCollapsed={itemsCollapsed}
                                    handleItemsExpanded={handleItemsExpanded}
                                    widgetUtilities={sharedWidgetUtilities}
                                    scrollNavUtilities={{ scrollNavIDs, handleHoveredItem, handleActiveItem, encounterID }}
                                />
                            </div>
                        );
                    })}
                    {isLoading ? <Loader /> : null}
                    {/* <div className="" id={scrollNavIDs.refSUBJECTIVECC} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refSUBJECTIVECC)} onClick={() => handleActiveItem(scrollNavIDs.refSUBJECTIVECC)}>
                        <p className="text fs-13 font-b validate-color blue-bg w-max-content" onClick={() => handleItemsExpanded('CC')}>Chief Complaint</p>
                        {!itemsCollapsed?.['CC'] &&
                            (<div className="input mt-1">
                                <div className={"input"}>
                                    <textarea
                                        className="form-control"
                                        ref={textareaRef}
                                        onInput={adjustTextareaHeight}
                                        name="ChiefComplaint"
                                        id="ChiefComplaint"
                                        autoComplete='off'
                                        // placeholder="Add Chief Complaint here..."
                                        value={subjectiveData.ChiefComplaint}
                                        onChange={(e) => handleChange(e, 'Subjective')}
                                    />
                                </div>
                            </div>)}
                    </div> */}

                    {/* {defaultSelectedItems.historyofPresentIllness &&
                        <div className="" id={scrollNavIDs.refSUBJECTIVEHPI} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refSUBJECTIVEHPI)} onClick={() => handleActiveItem(scrollNavIDs.refSUBJECTIVEHPI)}>
                            <p className="text fs-13 font-b validate-color blue-bg w-max-content mb-1" onClick={() => handleItemsExpanded('HPI')}>History of Present Illness</p>
                            {!itemsCollapsed?.['HPI'] &&
                                (<div className='d-flex flex-column gap-1'>
                                    {["Fields", "Both"].includes(defaultSelectedItems.historyofPresentIllnessType) ?
                                        <>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content">HPI</p>
                                            <HPIFields setSaveHPIData={setSaveHPIData} hpiData={subjectiveData.HistoryOfPresentIllness} setSubjectiveData={setSubjectiveData} />
                                        </>
                                        : <></>}
                                    {["FreeText", "Both"].includes(defaultSelectedItems.historyofPresentIllnessType) ?
                                        <>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content">HPI Notes</p>
                                            <div className="">
                                                <TextEditor
                                                    quillRef={quillHPIRef}
                                                    value={subjectiveData.HistoryofPresentIllnessNotes}
                                                    setValue={(value) => handleChangeFreeText(value, 'HistoryofPresentIllnessNotes')}
                                                    placeholderReplacement={true}
                                                    customDropDown={{
                                                        'active': true,
                                                        'options': [
                                                            { value: PatientName, display: '$Name', },
                                                            { value: Age, display: '$Age', },
                                                            { value: DOB, display: '$DOB', },
                                                            { value: Address, display: '$Address', },
                                                            { value: MobileNumber, display: '$Phone', },
                                                            { value: Email, display: '$Email', },
                                                        ]
                                                    }}
                                                    placeholder={"Detail HPI Notes..."}
                                                />
                                            </div>
                                        </> : <></>}
                                </div>)}
                        </div>} */}
                    {/* {defaultSelectedItems?.reviewOfSystem &&
                        <div className="" id={scrollNavIDs.refSUBJECTIVEROS} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refSUBJECTIVEROS)} onClick={() => handleActiveItem(scrollNavIDs.refSUBJECTIVEROS)}>
                            <p className="text fs-13 font-b validate-color blue-bg w-max-content mb-1" onClick={() => handleItemsExpanded('ROS')}>Review of System</p>
                            {!itemsCollapsed?.['ROS'] &&
                                (<div className='d-flex flex-column gap-1'>
                                    {["Fields", "Both"].includes(defaultSelectedItems.reviewOfSystemType) ?
                                        <>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content">ROS</p>
                                            <ROSFields setSaveROSData={setSaveROSData} rosData={subjectiveData.ReviewOfSystem} setSubjectiveData={setSubjectiveData} />
                                        </>
                                        : <></>}
                                    {["FreeText", "Both"].includes(defaultSelectedItems.reviewOfSystemType) ?
                                        <>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content">ROS Notes</p>
                                            <div className="">
                                                <TextEditor
                                                    quillRef={quillROSRef}
                                                    value={subjectiveData.ReviewOfSystemNotes}
                                                    setValue={(value) => handleChangeFreeText(value, 'ReviewOfSystemNotes')}
                                                    placeholderReplacement={true}
                                                    customDropDown={{
                                                        'active': true,
                                                        'options': [
                                                            { value: PatientName, display: '$Name', },
                                                            { value: Age, display: '$Age', },
                                                            { value: DOB, display: '$DOB', },
                                                            { value: Address, display: '$Address', },
                                                            { value: MobileNumber, display: '$Phone', },
                                                            { value: Email, display: '$Email', },
                                                        ]
                                                    }}
                                                    placeholder={"Detail ROS Notes..."}
                                                />
                                            </div>
                                        </> : <></>}
                                </div>)}
                        </div>} */}

                    {/* {defaultSelectedItems?.problems &&
                        <div onMouseEnter={() => handleHoveredItem(scrollNavIDs.refASSESSMENTP)} onClick={() => handleActiveItem(scrollNavIDs.refASSESSMENTP)}>
                            <div className="d-flex justify-content-between align-items-center" id={scrollNavIDs.refASSESSMENTP} >
                                <p className="text fs-13 font-b validate-color blue-bg w-max-content " onClick={() => handleItemsExpanded('P')}>Problems</p>
                                <div className="d-flex gap-2 align-items-center">
                                    <div className="all_problems-preview position-relative">
                                        {lastEncounterProblems?.Problems?.length > 0 ?
                                            <>
                                                <p className='text validate-color br-right-1 br-clr pe-2 cursor-pointer user-select-none' onClick={handleApplyProblems}>{lastEncounterProblems?.EncounterDate} - Problems</p>
                                                <div className="problem-content d-flex flex-column gap-2 hover-scrollbar">
                                                    {lastEncounterProblems?.Problems?.map(prob => (
                                                        <div className="d-flex align-items-center justify-content-between gap-20">
                                                            <p className="text font-m">{prob.DiagnosisCode}</p>
                                                            <p className="text font-m text-nowrap singleLine-ellispis">{prob?.Description}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </> : <></>}
                                    </div>
                                    <div className='input claims_info problems-search'>
                                        <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                                        <div className="position-relative za-denied-status Icds">
                                            <SuperICDandCPTSearch
                                                type='server'
                                                key={PatDxData?.length}
                                                placeholder={'Add Problem'}
                                                customData={RecentICDs}
                                                id='Dx'
                                                name='ProblemName'
                                                onChange={handleDeviceChange}
                                                getSelectedData={handleSelectedData}
                                                searchValue={mainProblemsModal.ProblemName}
                                                searchBy={['display', 'Description']}
                                                tableData={[
                                                    { columName: 'Code', bindingValue: 'display', },
                                                    { columName: 'Description', bindingValue: 'Description', },
                                                ]}
                                                ApiLink={API_URL + "/ICDInstantSearch"}
                                                method='post'
                                                postBody={icdBody}
                                                disabled={true}
                                                // ScrollOutside={false}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                // isItemSelected={!isNull(mainDiagnosisModal.ICD6Code) ? true : false}
                                                handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                                PatDxData={PatDxData}
                                                showPatDx={true}
                                                DefaultActiveTab='MyDXList'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {console.log("assessmentDataEncounterProblem", assessmentData?.EncounterProblem)}
                            {!itemsCollapsed?.['P'] &&
                                (<>
                                    {assessmentData?.EncounterProblem?.length > 0 &&
                                        (<div className="d-flex flex-column gap-2 hover-scrollbar problem-scroll px-1-5 py-2 assesment-box mb-12 mt-1">

                                            {(assessmentData?.EncounterProblem?.length > 0 ?
                                                <>
                                                    {assessmentData?.EncounterProblem.map(item => {
                                                        let inActive = item?.isActive ? !(item.isActive === "true") : false;
                                                        let isSaved = true;
                                                        if (inActive && !showInActiveProblems && isSaved) return;
                                                        return (
                                                            <div className="d-flex align-items-center justify-content-between gap-1">
                                                                <div className="d-flex align-items-center gap-1 w-100">
                                                                    <p className="text validate-color cursor-pointer font-m" onClick={() => AddProblems(item.PatientProblemListID, item)}> {item.DiagnosisCode}</p>

                                                                    {item.Description ?
                                                                        <p className="text singleLine-ellispis"> - {item.Description}</p> :
                                                                        (item.Description &&
                                                                            <p className="text singleLine-ellispis"> - {item.Description}</p>)}
                                                                </div>

                                                                <div className="d-flex gap-10 align-items-center ps-10">
                                                                    <div className="d-flex align-items-center gap-1 text-nowrap">
                                                                        {item.isActive === "true" ? <></> :
                                                                            item.isActive === "false" ?
                                                                                <p className="text Partialdenied-clr fst-italic text-nowrap pe-1">InActive </p> :
                                                                                <></>}

                                                                        {item.StartDate ?
                                                                            <>
                                                                                <p className="text font-m">Start Date:</p>
                                                                                <p className="text">{item.StartDate}</p>
                                                                            </> : <></>}
                                                                    </div>
                                                                    <div className="lh-1">
                                                                        <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleProblemDelete(item)}></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                    <ShowHideInActive />
                                                </> :
                                                <>
                                                </>)}
                                        </div>
                                        )}</>)}
                        </div>} */}

                    {/* <div id={scrollNavIDs.refOBJECTIVEN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refOBJECTIVEN)} onClick={() => handleActiveItem(scrollNavIDs.refOBJECTIVEN)}>
                        <p className="text fs-13 font-b validate-color blue-bg w-max-content" onClick={() => handleItemsExpanded('B')}>Behaviour</p>
                        {!itemsCollapsed?.['B'] &&
                            (
                                <div className="mt-1">
                                    <TextEditor
                                        quillRef={quillObjectiveBehaviourRef}
                                        value={objectiveData.BehaviourNotes}
                                        setValue={(value) => handleChangeFreeText(value, 'Behaviour')}
                                        placeholderReplacement={true}
                                        customDropDown={{
                                            'active': true,
                                            'options': [
                                                { value: PatientName, display: 'Name', },
                                                { value: Age, display: '$Age', },
                                                { value: DOB, display: '$DOB', },
                                                { value: Address, display: '$Address', },
                                                { value: MobileNumber, display: '$Phone', },
                                                { value: Email, display: '$Email', },
                                            ]
                                        }}
                                        placeholder={"Detail the patient's observed behaviours and reported experiences both inside and outside of sessions..."}
                                    />
                                </div>
                            )}
                    </div> */}
                    {/* <div id={scrollNavIDs.refINTERVENTIONN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refINTERVENTIONN)} onClick={() => handleActiveItem(scrollNavIDs.refINTERVENTIONN)}>
                        <p className="text fs-13 font-b validate-color blue-bg w-max-content" onClick={() => handleItemsExpanded('I')}>Intervention</p>
                        {!itemsCollapsed?.['I'] &&
                            (
                                <div className="mt-1">
                                    <TextEditor
                                        quillRef={quillInterventionRef}
                                        value={interventionData.InterventionNotes}
                                        setValue={(value) => handleChangeFreeText(value, 'Intervention')}
                                        placeholderReplacement={true}
                                        customDropDown={{
                                            'active': true,
                                            'options': [
                                                { value: PatientName, display: '$Name', },
                                                { value: Age, display: '$Age', },
                                                { value: DOB, display: '$DOB', },
                                                { value: Address, display: '$Address', },
                                                { value: MobileNumber, display: '$Phone', },
                                                { value: Email, display: '$Email', },
                                            ]
                                        }}
                                        placeholder={"Detail the specific therapeutic interventions or techniques used during the session..."}
                                    />
                                </div>)}
                    </div> */}

                    {/* <div id={scrollNavIDs.refRESPONSEN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refRESPONSEN)} onClick={() => handleActiveItem(scrollNavIDs.refRESPONSEN)}>
                        <p className="text fs-13 font-b validate-color blue-bg w-max-content" onClick={() => handleItemsExpanded('R')}>Response</p>
                        {!itemsCollapsed?.['R'] &&
                            (
                                <div className="mt-1">
                                    <TextEditor
                                        quillRef={quillResponseRef}
                                        value={assessmentData.ResponseNotes}
                                        setValue={(value) => handleChangeFreeText(value, 'Response')}
                                        placeholderReplacement={true}
                                        customDropDown={{
                                            'active': true,
                                            'options': [
                                                { value: PatientName, display: '$Name', },
                                                { value: Age, display: '$Age', },
                                                { value: DOB, display: '$DOB', },
                                                { value: Address, display: '$Address', },
                                                { value: MobileNumber, display: '$Phone', },
                                                { value: Email, display: '$Email', },
                                            ]
                                        }}
                                        placeholder={"Detail the patient's reaction to the interventions, including any positive or negative changes, resistance, or breakthroughs..."}
                                    />
                                </div>)}
                    </div> */}

                    {/* } */}
                    {/* </div> */}

                    {/* PLAN */}
                    {/* <div id={scrollNavIDs.refPLAN}>
                        <div className="ar_header d-flex gap-6 align-items-center mb-1" onClick={() => handleAccordionChange('PLAN')}>
                            {activeAccord['PLAN'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                            <p className="text fs-13 font-b validate-color blue-bg">P - PLAN</p>
                        </div>
                        {activeAccord['PLAN'] &&
                            <div className='d-flex flex-column gap-1'>


                                {defaultSelectedItems?.prescriptions &&
                                    <div className="" id={scrollNavIDs.refPLANPrescriptions} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANPrescriptions)} onClick={() => handleActiveItem(scrollNavIDs.refPLANPrescriptions)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PP')}>Prescriptions</p>
                                        {!itemsCollapsed?.['PP'] &&
                                            (
                                                <div className="mt-1">
                                                    <TextEditor
                                                        quillRef={quillPrescriptionsRef}
                                                        value={planData.PrescriptionsNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'PrescriptionsNotes')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        placeholder={"Detail medication name, dosage, route, frequency, duration and any special instruction..."}
                                                    />
                                                </div>
                                            )}
                                    </div>}
                                {defaultSelectedItems?.supplements &&
                                    <div className="" id={scrollNavIDs.refPLANSupplements} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANSupplements)} onClick={() => handleActiveItem(scrollNavIDs.refPLANSupplements)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PSupp')}>Supplements</p>
                                        {!itemsCollapsed?.['PSupp'] &&
                                            (
                                                <div className="mt-1">
                                                    <TextEditor
                                                        quillRef={quillSupplementsRef}
                                                        value={planData.SupplementsNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'SupplementsNotes')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        placeholder={"Detail supplement name, dosage, frequency and any special instructions..."}
                                                    />
                                                </div>
                                            )}
                                    </div>}
                                {defaultSelectedItems?.vaccines &&
                                    <div className="" id={scrollNavIDs.refPLANVaccines} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANVaccines)} onClick={() => handleActiveItem(scrollNavIDs.refPLANVaccines)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PVacc')}>Vaccines</p>
                                        {!itemsCollapsed?.['PVacc'] &&
                                            (
                                                <div className="mt-1">
                                                    <TextEditor
                                                        quillRef={quillVaccinesRef}
                                                        value={planData.VaccinesNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'VaccinesNotes')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        placeholder={"Detail vaccine name, dose, route..."}
                                                    />
                                                </div>
                                            )}
                                    </div>}
                                {defaultSelectedItems?.injections &&
                                    <div className="" id={scrollNavIDs.refPLANInjections} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANInjections)} onClick={() => handleActiveItem(scrollNavIDs.refPLANInjections)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PInj')}>Injections</p>
                                        {!itemsCollapsed?.['PInj'] &&
                                            (
                                                <div className="mt-1">
                                                    <TextEditor
                                                        quillRef={quillInjectionsRef}
                                                        value={planData.InjectionsNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'InjectionsNotes')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        placeholder={"Detail injection name, dose, route..."}
                                                    />
                                                </div>
                                            )}
                                    </div>}
                                {defaultSelectedItems?.labs &&
                                    <div className="" id={scrollNavIDs.refPLANLabs} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANLabs)} onClick={() => handleActiveItem(scrollNavIDs.refPLANLabs)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PL')}>Labs</p>
                                        {!itemsCollapsed?.['PL'] &&
                                            (
                                                <div className="mt-1">
                                                    <TextEditor
                                                        quillRef={quillLabsRef}
                                                        value={planData.LabsNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'LabsNotes')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        placeholder={"Detail lab test, reason and any special instructions..."}
                                                    />
                                                </div>
                                            )}
                                    </div>}
                                {defaultSelectedItems?.imaging &&
                                    <div className="" id={scrollNavIDs.refPLANImaging} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANImaging)} onClick={() => handleActiveItem(scrollNavIDs.refPLANImaging)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PImg')}>Imaging</p>
                                        {!itemsCollapsed?.['PImg'] &&
                                            (
                                                <div className="mt-1">
                                                    <TextEditor
                                                        quillRef={quillImagingRef}
                                                        value={planData.ImagingNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'ImagingNotes')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                        placeholder={"Detail imaging type, body area and any notes..."}
                                                    />
                                                </div>
                                            )}
                                    </div>}

                                <div id={scrollNavIDs.refPLANN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANN)} onClick={() => handleActiveItem(scrollNavIDs.refPLANN)}>
                                    <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('PN')}>Notes</p>
                                    {!itemsCollapsed?.['PN'] &&
                                        (<div className='mt-1'>
                                            <TextEditor
                                                quillRef={quillPlanRef}
                                                value={planData.PlanNotes}
                                                setValue={(value) => handleChangeFreeText(value, 'Plan')}
                                                placeholderReplacement={true}
                                                customDropDown={{
                                                    'active': true,
                                                    'options': [
                                                        { value: PatientName, display: '$Name', },
                                                        { value: Age, display: '$Age', },
                                                        { value: DOB, display: '$DOB', },
                                                        { value: Address, display: '$Address', },
                                                        { value: MobileNumber, display: '$Phone', },
                                                        { value: Email, display: '$Email', },
                                                    ]
                                                }}
                                                placeholder={"Next steps in the treatment process..."}
                                            />
                                        </div>)}
                                </div>

                                {defaultSelectedItems?.followUp &&
                                    <div className="" id={scrollNavIDs.refPLANFollowUp} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPLANFollowUp)} onClick={() => handleActiveItem(scrollNavIDs.refPLANFollowUp)}>
                                        <p className="heading fs-13 cursor-pointer user-select-none w-max-content mb-1" onClick={() => handleItemsExpanded('FollowUp')}>Follow-Up</p>
                                        {!itemsCollapsed?.['FollowUp'] &&
                                            <div className='observation-content d-flex flex-column gap-2'>
                                                <div className='input w-25'>
                                                    <DatePicker
                                                        label={'Date'}
                                                        id="FollowUpDate"
                                                        value={planData.FollowUpDate}
                                                        handleCalendarChangefunc={date => setPlanData(prev => ({ ...prev, 'FollowUpDate': date }))}
                                                    />
                                                </div>
                                                <div className="">
                                                    <p className="heading fs-13 cursor-pointer user-select-none w-max-content mb-1" >Notes</p>
                                                    <div className="">
                                                        <TextEditor
                                                            quillRef={quillFollowUpRef}
                                                            value={planData.FollowUpNotes}
                                                            setValue={(value) => handleChangeFreeText(value, 'FollowUpNotes')}
                                                            placeholderReplacement={true}
                                                            customDropDown={{
                                                                'active': true,
                                                                'options': [
                                                                    { value: PatientName, display: '$Name', },
                                                                    { value: Age, display: '$Age', },
                                                                    { value: DOB, display: '$DOB', },
                                                                    { value: Address, display: '$Address', },
                                                                    { value: MobileNumber, display: '$Phone', },
                                                                    { value: Email, display: '$Email', },
                                                                ]
                                                            }}
                                                            placeholder={"Detail followup notes..."}
                                                        />
                                                    </div>
                                                </div>
                                            </div>}
                                    </div>}

                            </div>
                        }
                    </div> */}
                    {/* {insertPosition === 'Bottom' && 
                        <div className="" id={scrollNavIDs.refCF} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refCF)} onClick={() => handleActiveItem(scrollNavIDs.refCF)}>
                            <CustomTemplateForm customTemplateData={props?.customTemplateData} setCustomTemplateData={props?.setCustomTemplateData} setSaveCustomTemplateData={props?.setSaveCustomTemplateData}  validations={props?.validations} itemsCollapsed={itemsCollapsed} handleItemsExpanded={handleItemsExpanded} />
                        </div>} */}

                    {/* {(defaultSelectedItems?.documents || defaultSelectedItems?.additionalNotes) &&
                        (<div id={scrollNavIDs.refAdditionalINFO}>
                            <div className="ar_header d-flex gap-6 align-items-center" onClick={() => handleAccordionChange('AdditionalINFO')}>
                                {activeAccord['AdditionalINFO'] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                                <p className="text fs-13 font-b validate-color blue-bg">I - Additional INFO</p>
                            </div>
                            {activeAccord['AdditionalINFO'] &&
                                (<div className='d-flex flex-column gap-1 mt-1'>
                                    {defaultSelectedItems?.documents &&
                                        <div onMouseEnter={() => handleHoveredItem(scrollNavIDs.refAdditionalINFODOC)} onClick={() => handleActiveItem(scrollNavIDs.refAdditionalINFODOC)}>
                                            <div className="d-flex justify-content-between align-items-center" id={scrollNavIDs.refAdditionalINFODOC}>
                                                <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('D')}>Documents</p>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div onClick={() => AddDocument({ PatientDocumentID: null })}>
                                                        <i className="icon-dash-plus add-icon rounded-5 fs-20" ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            {!itemsCollapsed?.['D'] && (<>
                                                {additionalInfoData?.EncounterDocument?.length > 0 &&
                                                    <div className="py-2 px-1-5 assesment-box mb-1 d-flex flex-column gap-2 mt-1">

                                                        {additionalInfoData?.EncounterDocument.map((doc, index) => {
                                                            let docType = DropdownValueHandler(DropDowns.DocumentType, doc.DocumentTypeID)
                                                            return (
                                                                <>
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <p className='text validate-color cursor-pointer text-nowrap br-right-1 br-clr-light pe-2' onClick={() => AddDocument(doc)}>{doc.FileName}</p>
                                                                        <p className="text font-m text-nowrap">Document Type:</p>
                                                                        <p className={`text text-nowrap pe-2 ${doc.Description ? 'br-right-1 br-clr-light' : ''} `}>{docType}</p>

                                                                        {doc.Description ? <p className="text font-m text-nowrap">Description:</p> : <></>}
                                                                        <p className='text text-nowrap validation_message w-100'>{doc.Description}</p>
                                                                        <div className="d-flex gap-10 align-items-center ps-10">
                                                                            <div className="lh-1">
                                                                                <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleDocumentDelete(doc, index)}></i>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>


                                                            )
                                                        })}
                                                    </div>}
                                            </>)}
                                        </div>}
                                    {defaultSelectedItems?.additionalNotes &&
                                        <div className="" id={scrollNavIDs.refAdditionalINFON} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refAdditionalINFON)} onClick={() => handleActiveItem(scrollNavIDs.refAdditionalINFON)}>
                                            <p className="heading fs-13 cursor-pointer user-select-none w-max-content" onClick={() => handleItemsExpanded('IN')}>Notes</p>
                                            {!itemsCollapsed?.['IN'] && (
                                                <div className='mt-1'>
                                                    <TextEditor
                                                        quillRef={quillAdditionalInfoRef}
                                                        value={additionalInfoData.AdditionalInfoNotes}
                                                        setValue={(value) => handleChangeFreeText(value, 'AdditionalInfo')}
                                                        placeholderReplacement={true}
                                                        customDropDown={{
                                                            'active': true,
                                                            'options': [
                                                                { value: PatientName, display: '$Name', },
                                                                { value: Age, display: '$Age', },
                                                                { value: DOB, display: '$DOB', },
                                                                { value: Address, display: '$Address', },
                                                                { value: MobileNumber, display: '$Phone', },
                                                                { value: Email, display: '$Email', },
                                                            ]
                                                        }}
                                                    />
                                                </div>)}
                                        </div>}
                                </div>)}
                        </div>)} */}

                    {/* {defaultSelectedItems?.qualityOfCare && */}
                    {/* <div className='bg_yellow p-2'>
                            <p className='heading font-b fs-13 mb-1 leter-spacing'>Quality of Care</p>
                            <div className="ar_content">
                                <div className="d-flex gap-40 align-items-center">

                                    <div className="d-flex flex-column gap-2">

                                        <label className="d-flex align-items-center gap-6">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    name="SummaryOfCareSent"
                                                    checked={qualityOfCareData?.SummaryOfCareSent === "true"}
                                                    onChange={handleQualityOfCare}
                                                />
                                            </div>
                                            <p className="text">Summary of care sent</p>
                                        </label>

                                        <label className="d-flex align-items-center gap-6">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    name="IncomingTransferOfPatient"
                                                    checked={qualityOfCareData?.IncomingTransferOfPatient === "true"}
                                                    onChange={handleQualityOfCare}
                                                />
                                            </div>
                                            <p className="text">Incoming transfer of care</p>
                                        </label>

                                        <label className="d-flex align-items-center gap-6">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    name="OutgoingTransferOfCare"
                                                    checked={qualityOfCareData?.OutgoingTransferOfCare === "true"}
                                                    onChange={handleQualityOfCare}
                                                />
                                            </div>
                                            <p className="text">Outgoing transfer of care</p>
                                        </label>
                                    </div>
                                    <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    name="EducationMaterialGiven"
                                                    checked={qualityOfCareData?.EducationMaterialGiven === "true"}
                                                    onChange={handleQualityOfCare}
                                                />
                                            </div>
                                            <p className="text">Education material given</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    name="PatientDeclinedSummary"
                                                    checked={qualityOfCareData?.PatientDeclinedSummary === "true"}
                                                    onChange={handleQualityOfCare}
                                                />
                                            </div>
                                            <p className="text">Patient declined summary</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    name="VirtualVisit"
                                                    checked={qualityOfCareData?.VirtualVisit === "true"}
                                                    onChange={handleQualityOfCare}
                                                />
                                            </div>
                                            <p className="text">Virtual visit</p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    {/* } */}

                    {/* <div className='bg_yellow p-2'>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className='heading font-b fs-13 mb-1 leter-spacing' id={`SuperBill-${initialData?.Data?.EncounterID}`}>SUPERBILL</p>
                            <>
                                {!isNull(initialData?.Data?.EncounterID) &&
                                    (!isNull(initialData?.Data?.ClaimID) ?
                                        (<div className={`d-flex align-items-center cursor-pointer ${isClaimViewAllowed ? '' : 'disable'}`}>
                                            <p className='heading fs-11 validate-color' onClick={handleViewClaim}>View Claim</p>
                                            <i className='icon-enrollment fs-13 lh-9'></i>
                                        </div>) :

                                        <div className={`d-flex align-items-center cursor-pointer ${isCreateClaimEditAllowed ? '' : 'disable'}`}>
                                            {(dataExist ?
                                                (divClaimLinking) :
                                                (
                                                    mainServiceLineModal?.some(serviceLine => !isNull(serviceLine.SuperBillID)) ?
                                                        <div className='d-flex align-items-center cursor-pointer' onClick={handleCreateClaim}>
                                                            <p className='heading fs-11 validate-color'>Create Claim</p>
                                                            <i className='icon-enrollment fs-13 lh-9'></i>
                                                        </div>
                                                        :
                                                        <></>

                                                ))}
                                        </div>)}
                            </>
                        </div>
                        <div className="ar_content mb-2">
                            <div className="d-flex align-items-center gap-1 icds-content">
                                <p className='heading pe-1'>ICD(s)</p>
                                {assessmentData?.EncounterProblem?.length > 0 &&
                                    (assessmentData?.EncounterProblem?.map(prob => (
                                        <p className='text'>{prob?.DiagnosisCode}</p>
                                    )))}
                            </div>
                        </div>
                        <div className="d-flex align-items-center gap-1 mb-1 justify-content-between">
                            <div className='d-flex align-items-center gap-1'>
                                <p className='heading font-b fs-13 leter-spacing'>Procedure Codes</p>
                                <div className={isSuperbillEditAllowed ? '' : 'disable'}>
                                    {isProcedureEdit ?
                                        <i className='icon-x-cros gray-clr fw-900' onClick={handleEditProcedure}></i> :
                                        <i className='icon-Icon-material-edit ar-light-color fs-11' onClick={handleEditProcedure}></i>}
                                </div>
                            </div>

                            <div className={`d-flex align-items-center gap-1 ${isSuperbillEditAllowed ? '' : 'disable'}`}>
                                <div className="all_problems-preview position-relative">
                                    {lastEncounterCPTs?.CPTs?.length > 0 ?
                                        <>
                                            <p className={`text validate-color cursor-pointer user-select-none ${isProcedureEdit ? 'br-right-1 br-clr pe-2' : ''}`} onClick={handleApplyCPTs}>{lastEncounterCPTs?.EncounterDate} - CPTs</p>
                                            <div className="problem-content d-flex flex-column gap-2 hover-scrollbar ">
                                                {lastEncounterCPTs?.CPTs?.map(cpt => (
                                                    <div className="d-flex align-items-center justify-content-between gap-20">
                                                        <p className="text font-m">{cpt.ProcedureCode}</p>
                                                        <p className="text font-m text-nowrap singleLine-ellispis" title={cpt?.Description}>{cpt?.Description}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </> : <></>}
                                </div>
                                {isProcedureEdit ?
                                    <div className='input claims_info problems-search'>

                                        <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                                        <div className="position-relative za-denied-status Icds">

                                            <SuperICDandCPTSearch
                                                type='server'
                                                customData={RecentCPTs}
                                                placeholder={'Add Procedure'}
                                                id='ProcedureCode'
                                                name='ProcedureCode'
                                                onChange={(e) => handleServiceLineChange(e, 'data.RowID', 'index', 'ProcedureCode', 'isMainCPTEncounterCustomNote')}
                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, 'index', 'ProcedureCode', false, 'CPT')}
                                                searchValue={CPTModal.CPT}
                                                searchBy={['display', 'Description']}
                                                tableData={[
                                                    { columName: 'Code', bindingValue: 'display', },
                                                    { columName: 'Description', bindingValue: 'Description', },
                                                ]}
                                                ApiLink={API_URL + "/CPTInstantSearch"}
                                                method='post'
                                                postBody={cptBody}
                                                disabled={true}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name, 'index')}
                                                isReadOnly={!isSuperbillEditAllowed}
                                            />
                                        </div>
                                    </div> : <></>}
                            </div>
                        </div>

                        <div className="hk-expand-table overflow-auto BorderLess-table">
                            <table className="w-100">
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th className='w-212px'>Modifiers</th>
                                        <th className='w-130px'>Pointers</th>
                                        <th className='w-130px'>Units</th>
                                        {isProcedureEdit ? <th className='w-0px'></th> : <></>}
                                    </tr>
                                </thead>
                                {isProcedureEdit ?
                                    <tbody>
                                        <>
                                            {mainServiceLineModal?.map((data, index) => {
                                                let displayProcedureCode = data?.ProcedureCode;
                                                let CheckValidation = areAllValuesNullOrEmpty(serviceLineValidation[index])
                                                let amountVals = {}?.[data?.ServiceLineID];
                                                const AmountValidationExist = amountVals ? Object.values(amountVals).some(value => value) : null;
                                                let VISIT_PAYMENT_index = '';
                                                if (data?.Deleted !== "true") {
                                                    return (
                                                        <>
                                                            <tr key={data.ServiceLineID}>
                                                                <td className='position-relative'>
                                                                    <div className='input select-bg-img'>
                                                                        {displayProcedureCode}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='hk-table-flex' >
                                                                        <div>
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode1'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode1', '', 'CPT')}
                                                                                searchValue={data.ModifierCode1}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                placeholder={false}
                                                                                isItemSelected={!isNull(data.ModifierCode1) ? true : false}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode2'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode2', '', 'CPT')}
                                                                                searchValue={data.ModifierCode2}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                placeholder={false}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                isItemSelected={!isNull(data.ModifierCode2) ? true : false}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode3'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode3', '', 'CPT')}
                                                                                searchValue={data.ModifierCode3}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                placeholder={false}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                isItemSelected={!isNull(data.ModifierCode3) ? true : false}
                                                                            />
                                                                        </div>
                                                                        <div>
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode4'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode4', '', 'CPT')}
                                                                                searchValue={data.ModifierCode4}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                placeholder={false}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                isItemSelected={!isNull(data.ModifierCode4) ? true : false}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className='hk-table-flex'>
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer1ICD) ? 'form-control input_error' : 'form-control'}
                                                                            name="Pointer1"
                                                                            id="Pointer1"
                                                                            maxLength={2}
                                                                            value={data.Pointer1}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer1')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        />
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                !isNull(serviceLineValidation[index]?.Pointer2ICD) ? 'form-control input_error' : 'form-control'}
                                                                            name="Pointer2"
                                                                            id="Pointer2"
                                                                            maxLength={2}
                                                                            value={data.Pointer2}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer2')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        />
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={
                                                                                !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer3ICD) ? 'form-control input_error' : 'form-control'}
                                                                            name="Pointer3"
                                                                            id="Pointer3"
                                                                            maxLength={2}
                                                                            value={data.Pointer3}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer3')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        />
                                                                        <input
                                                                            variant="outlined"
                                                                            type="text"
                                                                            className={
                                                                                !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                                    !isNull(serviceLineValidation[index]?.Pointer4ICD) ? 'form-control input_error' : 'form-control'}
                                                                            name="Pointer4"
                                                                            id="Pointer4"
                                                                            maxLength={2}
                                                                            value={data.Pointer4}
                                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer4')}
                                                                            onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            onKeyPress={handleNumericCheck}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td >
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control units unit ${!isNull(serviceLineValidation[index]?.UnitsVal) ? 'error' : ''}`}
                                                                        name="Units"
                                                                        id="Units"
                                                                        variant="outlined"
                                                                        value={data.Units}
                                                                        onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Units')}
                                                                    />

                                                                </td>
                                                                <td className='text-center'>
                                                                    <span onClick={() => handleDeleteRow(index)}><i class="fs-14 icon-delete" style={{ color: 'red' }}></i></span>
                                                                </td>
                                                            </tr>
                                                            {CheckValidation === true ? null :
                                                                <tr>
                                                                    <td colSpan={12} className='message error_message'>
                                                                        {!isNull(serviceLineValidation[index]?.DOSFromVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSFromVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.DOSToVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSToVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.CPTCodeVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.CPTCodeVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.ModifierCode1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1Val} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1UNI} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1Val} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1UNI} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer1ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer2ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer2ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer3ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer3ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.Pointer4ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer4ICD} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.POSVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.POSVal} </p> : null}
                                                                        {!isNull(serviceLineValidation[index]?.UnitsVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.UnitsVal} </p> : null}
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </>
                                                    )
                                                }
                                            })}
                                        </>
                                    </tbody> :
                                    <tbody>
                                        {mainServiceLineModal?.map((data, index) => {
                                            let processedAsDD = [];
                                            let displayProcedureCode = data?.ProcedureCode;
                                            if (data?.Deleted !== "true") {
                                                return (
                                                    <>
                                                        <tr key={data.ServiceLineID}>
                                                            <td className='position-relative'>
                                                                <div className='input select-bg-img'>
                                                                    {displayProcedureCode}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hk-table-flex' >
                                                                    {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                                        .filter(Boolean)
                                                                        .join(', ')}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='hk-table-flex'>
                                                                    {[data.Pointer1, data.Pointer2, data.Pointer3, data.Pointer4]
                                                                        .filter(Boolean)
                                                                        .join(', ')}
                                                                </div>
                                                            </td>
                                                            <td>{data.Units}</td>
                                                        </tr>
                                                    </>
                                                )
                                            }
                                        })}
                                    </tbody>}
                            </table>
                        </div>

                    </div> */}
                </div>}
            <PrintOutSelectDataModal printoutSelectDataModal={printoutSelectDataModal} setPrintoutSelectDataModal={setPrintoutSelectDataModal} setPrintoutModal={setPrintoutModal} selectedItems={selectedItems} setSelectedItems={setSelectedItems} showAddressTypeLocation={showAddressTypeLocation} setShowAddressTypeLocation={setShowAddressTypeLocation} id={encounterID} insertPosition={insertPosition} customTemplateData={props?.customTemplateData} mainCustomTemplateData={props?.mainCustomTemplateData} />
            <Modal show={printoutModal} onHide={printoutModal} backdrop="static" keyboard={false} centered dialogClassName="ar_encounter_print_modal ar_encounter_main_screen ar_encounter_preview_sceen p-0 hk-modal-v1 table-default-design bg-transparent" >
                {isLoadingPdf && <Loader />}
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-center gap-2 pt-15 ar_print-header pb-2">
                        <span class="icon-Group-1000002858 fs-20" onClick={() => captureDataAndGeneratePDF(componentRef, `${initialData?.Data?.PatientName || customNoteType || 'CustomNote'} - ${searchParam?.EncounterDate}.pdf`, 'highRes')}>
                            <span class="path1"></span><span class="path2"></span>
                        </span>
                        <i className="icon-Icon-metro-cross fs-20" onClick={() => setPrintoutModal(false)}></i>
                    </div>
                    <div ref={componentRef}>
                        <div className={`px-10 pb-15 pt-2 ar_native_pdf_design encounter-notes-design ${selectedItems?.["uiDesign"] ? 'Black-in-White-Design' : ''}`}>
                            <SelectedPreviewDataV2 showAddressTypeLocation={showAddressTypeLocation} selectedItems={selectedItems} data={initialData} searchParam={searchParam} searchValue={searchValue} Data={{
                                ...(subjectiveData || {}),
                                ...(objectiveData || {}),
                                ...(assessmentData || {}),
                                ...(planData || {}),
                                ...(additionalInfoData || {}),
                                'CustomTemplateData': props?.customTemplateData,
                                "MainCustomTemplateData": props?.mainCustomTemplateData,
                                "BehaviourNotes": objectiveData?.BehaviourNotes,
                                "InterventionNotes": interventionData?.InterventionNotes,
                                "ResponseNotes": assessmentData?.ResponseNotes,
                                "PlanNotes": planData?.PlanNotes,
                                "AdditionalInfoNotes": additionalInfoData?.AdditionalInfoNotes,
                                "mainServiceLineModal": mainServiceLineModal,
                                "vitalData": vitalData,
                                "EncounterCoSignData": initialData?.EncounterCoSign || [],
                            }} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
})

export default CustomNote